// Generated from server data/aevian-web-moves.ts.
const AEVIAN_WEB_MOVE_SOURCES: {[id:string]:string[]} = {"splinteredweb":["9L0"],"uturn":["9L1"],"glare":["9L1"],"rocksmash":["9L1"],"rockthrow":["9L4"],"rockpolish":["9L15"],"rockblast":["9L29"],"rocktomb":["9L31"],"partingshot":["9L33"],"fling":["9L34"],"stealthrock":["9L43"],"crosschop":["9L47"],"acrobatics":["9L49"],"stoneedge":["9L56"],"knockoff":["9L60"],"finalgambit":["9L67"],"arenitewall":["9M"],"assurance":["9M"],"beatup":["9M"],"brickbreak":["9M"],"brutalswing":["9M"],"dig":["9M"],"doubleedge":["9M"],"facade":["9M"],"irondefense":["9M"],"lashout":["9M"],"poisonsweep":["9M"],"pounce":["9M"],"revenge":["9M"],"rockslide":["9M"],"slashandburn":["9M"],"snatch":["9M"],"spikes":["9M"],"stackingshot":["9M"],"stompingtantrum":["9M"],"strength":["9M"],"superpower":["9M"],"swagger":["9M"],"trailblaze":["9M"]};
const AEVIAN_WEB_ORDINARY_MOVES = ["doubleedge","facade","pounce","swagger"];
// Generated from server data/aevian-ascendance-moves.ts.
const AEVIAN_ASCENDANCE_MOVE_SOURCES: {[id:string]:string[]} = {"scentedgeyser":["9L0"],"purify":["9L1"],"meditate":["9L1"],"aurasphere":["9L1"],"round":["9L11"],"healbell":["9L18"],"dragonbreath":["9L21"],"hypervoice":["9L38"],"dragonpulse":["9L41"],"recover":["9L46"],"calmmind":["9L57"],"haze":["9L60"],"defog":["9M"],"dracometeor":["9M"],"dragoncheer":["9M"],"outrage":["9M"]};
const AEVIAN_ASCENDANCE_ORDINARY_MOVES = ["meditate","round","haze"];
// Generated from server data/aevian-king-moves.ts; ordinary moves stay in the normal pool.
const AEVIAN_KING_MOVE_SOURCES: {[id:string]:string[]} = {"dragoncheer":["9L0"],"purify":["9L1"],"round":["9L11"],"healbell":["9L18"],"dragonbreath":["9L21"],"lifedew":["9L30"],"hypervoice":["9L38"],"megahorn":["9L41"],"dragonpulse":["9L43"],"instruct":["9L50"],"fakeout":["9L57"],"haze":["9L60"],"recover":["9L65"],"aurasphere":["9M"],"bounce":["9M"],"calmmind":["9M"],"defog":["9M"],"dracometeor":["9M"],"dragonclaw":["9M"],"naturepower":["9M"],"outrage":["9M"],"slackoff":["9M"],"thunderwave":["9M"],"uproar":["9M"],"weatherball":["9M"]};
const AEVIAN_KING_ORDINARY_MOVES = ["round","hypervoice","haze","bounce","uproar","weatherball"];
/**
 * Search
 *
 * Code for searching for dex information, used by the Dex and
 * Teambuilder.
 *
 * Dependencies: battledata, search-index
 * Optional dependencies: pokedex, moves, items, abilities
 *
 * @author Guangcong Luo <guangcongluo@gmail.com>
 * @license MIT
 */

type SearchType = (
	'pokemon' | 'type' | 'tier' | 'move' | 'item' | 'ability' | 'egggroup' | 'category' | 'article'
);

type SearchRow = (
	[SearchType, ID, number?, number?] | ['sortpokemon' | 'sortmove', ''] | ['header' | 'html', string]
);

type SearchFilter = [string, string];

function dedupeSearchResults(results: SearchRow[]): SearchRow[] {
	const seen = new Set<string>();
	return results.filter(row => {
		if (!['pokemon', 'type', 'tier', 'move', 'item', 'ability', 'egggroup', 'category', 'article'].includes(row[0])) {
			return true;
		}
		const key = `${row[0]}:${row[1]}`;
		if (seen.has(key)) return false;
		seen.add(key);
		return true;
	});
}

/** ID, SearchType, index (if alias), offset (if offset alias) */
declare const BattleSearchIndex: [ID, SearchType, number?, number?][];
declare const BattleSearchIndexOffset: any;
declare const BattleTeambuilderTable: any;

// Fan-made standalone species and movie props are kept for battle/replay data,
// but are not selectable in the team builder (including exact-name searches).
const HIDDEN_FAKE_SPECIES = new Set<string>([
	'raidboss', 'missingno', 'chuggon', 'draggalong', 'chuggalong', 'shox',
	'ramnarok', 'ramnarokradiant',
]);

function isHiddenFakeSpecies(id: string) {
	const speciesId = toID(id);
	return HIDDEN_FAKE_SPECIES.has(speciesId) || speciesId.startsWith('pokestar');
}

const HIDDEN_TEAMBUILDER_SPECIES = new Set<string>([
	'pikachualola', 'pikachucosplay', 'pikachuhoenn', 'pikachukalos', 'pikachuoriginal',
	'pikachupartner', 'pikachusinnoh', 'pikachuunova', 'pikachuworld',
	'pikachubelle', 'pikachulibre', 'pikachuphd', 'pikachupopstar', 'pikachurockstar',
]);

// These are official ZA Mega forms in the client catalog, not custom skins.
// Keep them available for normal species lookup and battle rendering, but do
// not count them as custom additions in the explicit -custom list.
const ZA_MEGA_SPECIES = new Set<string>([
	'absolmegaz', 'baxcaliburmega', 'barbaraclemega', 'chandeluremega', 'chesnaughtmega',
	'chimechomega', 'clefablemega', 'crabominablemega', 'darkraimega', 'delphoxmega',
	'dragalgemega', 'dragonitemega', 'drampamega', 'eelektrossmega', 'emboarmega',
	'excadrillmega', 'feraligatrmega', 'floettemega', 'floetteeternalmega', 'froslassmega',
	'falinksmega', 'garchompmegaz', 'glimmoramega', 'golisopodmega', 'golurkmega', 'greninjamega',
	'hawluchamega', 'heatranmega', 'lucariomegaz', 'malamarmega', 'magearnamega',
	'magearnaoriginalmega', 'meganiummega', 'meowsticfmega', 'meowsticmmega', 'pyroarmega',
	'raichumegax', 'raichumegay', 'scolipedemega', 'scovillainmega', 'scraftymega',
	'skarmorymega', 'staraptormega', 'starmiemega', 'tatsugiricurlymega', 'tatsugiridroopymega',
	'tatsugiristretchymega', 'victreebelmega', 'zeraoramega', 'zygardemega',
]);

// These are visual-only destinations for Z Protean. They must remain resolvable
// for battle form changes, but are never valid team-builder choices.
const Z_PROTEAN_BATTLE_ONLY_SPECIES = new Set<string>([
	'braveon', 'nimbeon', 'toxeon', 'dusteon', 'basaleon', 'ephemeon',
	'kitsuneon', 'titaneon', 'byteon', 'drekeon',
]);

// Sinister Blaze Eevee is an event-style profile with an explicit pool. Keep
// this separate from Eevee-Starter's normal inherited learnset so the picker
// cannot leak ordinary Eevee moves into this profile.
const SINISTER_BLAZE_EEVEE_MOVES: readonly ID[] = [
	'sing', 'searingvoid', 'tackle', 'helpinghand', 'tailwhip', 'sandattack', 'batonpass',
	'strengthsap', 'torment', 'pursuit', 'moonlight', 'poisonfang', 'lovelykiss', 'punishment',
	'willowisp', 'spiritbreak', 'bittermalice', 'infernalparade', 'destinybond', 'dreameater',
	'memento', 'darkpulse', 'eeriespell', 'perishsong', 'blueflare', 'doomdesire',
	'alluringvoice', 'attract', 'aurasphere', 'bodyslam', 'burningjealousy', 'calmmind', 'celebrate',
	'charm', 'confuseray', 'curse', 'dig', 'echoedvoice', 'faketears', 'feintattack', 'firefang',
	'firepledge', 'firespin', 'flail', 'flamethrower', 'flash', 'focusenergy', 'foulplay', 'haze',
	'headbutt', 'healbell', 'healblock', 'hiddenpower', 'hex', 'hypervoice', 'icefang', 'icywind',
	'irontail', 'laserfocus', 'leechlife', 'lightscreen', 'mimic', 'mudslap', 'mysticalfire',
	'nightmare', 'nightshade', 'ominouswind', 'painsplit', 'payday', 'raindance', 'reflect',
	'retaliate', 'round', 'scorchingsands', 'shadowball', 'snarl', 'storedpower', 'sunnyday',
	'swagger', 'terrainpulse', 'thunderwave', 'uturn', 'weatherball', 'workup', 'lastresort',
	'babydolleyes', 'baddybad', 'bite', 'bouncybubble', 'buzzybuzz', 'captivate', 'copycat', 'covet',
	'detect', 'doubleedge', 'doublekick', 'dustydrift', 'endure', 'freezyfrost', 'glitzyglow', 'growl',
	'ickyinjection', 'naturalgift', 'naturepower', 'punchypummel', 'quickattack', 'rockyrampage',
	'sappyseed', 'scalyscorn', 'sizzlyslide', 'sparklyswirl', 'spookyspell', 'stabbyswarm',
	'steelystrike', 'swift', 'synchronoise', 'takedown', 'tickle', 'trailblaze', 'twirlytwister',
	'veeveevolley', 'wish', 'yawn', 'glitchygraphics',
] as ID[];

// Ascendance Eevee is an event-style profile with its own complete move pool.
// Keep it isolated from Eevee-Starter's normal inherited learnset.
const ASCENDANCE_EEVEE_MOVES: readonly ID[] = [
	'sing',
	'radiantassault', 'tackle', 'helpinghand', 'tailwhip', 'sandattack', 'batonpass',
	'aurorabeam', 'honeclaws', 'confusion', 'morningsun', 'sonicboom', 'punishment',
	'secretpower', 'healpulse', 'spiritbreak', 'mindreader', 'recover', 'luminacrash',
	'healingwish', 'dazzlinggleam', 'extremespeed', 'revivalblessing', 'sacredfire', 'judgment',
	'acrobatics', 'aerialace', 'agility', 'alluringvoice', 'ancientpower', 'attract', 'aurasphere',
	'auroraveil', 'bodyslam', 'calmmind', 'celebrate', 'charm', 'cosmicpower', 'crunch', 'curse',
	'defog', 'dig', 'disarmingvoice', 'dragonpulse', 'earthpower', 'echoedvoice', 'encore', 'endeavor',
	'expandingforce', 'faketears', 'falseswipe', 'flail', 'flamethrower', 'flash', 'flashcannon',
	'flipturn', 'focusenergy', 'futuresight', 'headbutt', 'healbell', 'heatwave', 'hiddenpower',
	'hurricane', 'hyperbeam', 'hypervoice', 'irontail', 'laserfocus', 'lightscreen', 'magiccoat',
	'meteorbeam', 'metronome', 'mimic', 'mudslap', 'mysticalfire', 'naturepower', 'payday', 'playrough',
	'psychic', 'psychicfangs', 'raindance', 'reflect', 'retaliate', 'round', 'scald', 'shadowball',
	'shockwave', 'storedpower', 'sunnyday', 'superfang', 'swagger', 'tailslap', 'tailwind',
	'terrainpulse', 'thunderfang', 'triattack', 'uturn', 'vacuumwave', 'weatherball', 'workup',
	'zenheadbutt', 'lastresort',
	'babydolleyes', 'baddybad', 'bite', 'bouncybubble', 'buzzybuzz', 'captivate', 'copycat', 'covet',
	'detect', 'doubleedge', 'doublekick', 'dustydrift', 'endure', 'freezyfrost', 'glitzyglow', 'growl',
	'ickyinjection', 'naturalgift', 'punchypummel', 'quickattack', 'rockyrampage', 'sappyseed',
	'scalyscorn', 'sizzlyslide', 'sparklyswirl', 'spookyspell', 'stabbyswarm', 'steelystrike', 'swift',
	'synchronoise', 'takedown', 'tickle', 'trailblaze', 'twirlytwister', 'veeveevolley', 'wish', 'yawn',
] as ID[];

const AEVIAN_GRIEF_MOVE_IDS: readonly ID[] = [
	'aerialace', 'airslash', 'allyswitch', 'ancientpower', 'astonish', 'aurasphere', 'calmmind', 'chargebeam',
	'cosmicpower', 'curse', 'darkpulse', 'dazzlinggleam', 'defog', 'drainingkiss', 'dreameater', 'dualwingbeat',
	'energyball', 'fairywind', 'firespin', 'flamethrower', 'flash', 'fly', 'futuresight', 'gigaimpact',
	'gravity', 'guardswap', 'heatwave', 'hex', 'hyperbeam', 'hypnosis', 'icywind', 'incinerate',
	'frustration', 'lightscreen', 'luckychant', 'magiccoat', 'magicroom', 'mindreader', 'miracleeye', 'mistyexplosion',
	'mistyterrain', 'moonblast', 'mysticalfire', 'nightshade', 'nightmare', 'ominouswind', 'painsplit', 'phantomforce',
	'poltergeist', 'powerswap', 'psychoshift', 'psychic', 'reflect', 'roost', 'safeguard', 'shadowball',
	'shadowclaw', 'shockwave', 'signalbeam', 'skillswap', 'solarbeam', 'spite', 'steelwing', 'storedpower',
	'tailwind', 'thief', 'thunderwave', 'trick', 'trickroom', 'whirlwind', 'willowisp', 'wonderroom',
] as ID[];

// These forms are created by battle abilities and are not valid stored team
// choices. They must remain resolvable to the battle renderer without adding
// clutter or invalid entries to the team builder.
const BATTLE_ONLY_VISUAL_SPECIES = new Set<string>([
	'auroreon', 'soluneon', 'abysseon', 'divineon',
]);

function isZProteanBattleOnlySpecies(id: string) {
	return Z_PROTEAN_BATTLE_ONLY_SPECIES.has(toID(id) as ID);
}

function isBattleOnlyVisualSpecies(id: string) {
	const speciesId = toID(id) as ID;
	return isZProteanBattleOnlySpecies(speciesId) || BATTLE_ONLY_VISUAL_SPECIES.has(speciesId);
}

function isCAPSpecies(id: string) {
	return Dex.species.get(id).isNonstandard === 'CAP';
}

function isTotemSpecies(species?: { isTotem?: boolean, forme?: string }) {
	return !!species && (species.isTotem || (species.forme || '').toLowerCase().split('-').includes('totem'));
}

// Hide only the nineteen official pattern skins; retain distinct custom forms and all data.
const VIVILLON_PATTERN_SPECIES = new Set<string>([
 'vivillonarchipelago', 'vivilloncontinental', 'vivillonelegant', 'vivillongarden',
 'vivillonhighplains', 'vivillonicysnow', 'vivillonjungle', 'vivillonmarine',
 'vivillonmodern', 'vivillonmonsoon', 'vivillonocean', 'vivillonpolar', 'vivillonriver',
 'vivillonsandstorm', 'vivillonsavanna', 'vivillonsun', 'vivillontundra',
 'vivillonfancy', 'vivillonpokeball',
]);

function isHiddenTeamBuilderSpecies(id: string, includeSawsbuckBase = false) {
	const speciesId = toID(id);
	if (Dex.isSpeciesHidden(speciesId)) return true;
	if (isCAPSpecies(speciesId) || isHiddenFakeSpecies(speciesId) || isTotemSpecies(window.BattlePokedex?.[speciesId])) return true;
	if (isBattleOnlyVisualSpecies(speciesId)) return true;
	if (HIDDEN_TEAMBUILDER_SPECIES.has(speciesId) || VIVILLON_PATTERN_SPECIES.has(speciesId)) return true;
	if (isVariantSelectorOnlySpecies(Dex.species.get(speciesId))) return true;
	if (speciesId === 'deerling' || speciesId.startsWith('deerling')) return true;
	if (speciesId.startsWith('sawsbuck') && !['sawsbuck', 'sawsbucksummer', 'sawsbuckautumn', 'sawsbuckwinter'].includes(speciesId)) return true;
	if (speciesId.startsWith('furfrou') && speciesId !== 'furfrou') return true;
	if (speciesId.startsWith('silvally') && speciesId !== 'silvally') return true;
	return false;
}

function isExcludedFromCustomSearch(id: string) {
	const speciesId = toID(id);
	// Balance-patched official records are not additional custom forms.
	return Dex.isSpeciesHidden(speciesId) || VIVILLON_PATTERN_SPECIES.has(speciesId) || isTotemSpecies(window.BattlePokedex?.[speciesId]) || ['unfezant', 'xerneasneutral'].includes(speciesId) ||
		isHiddenFakeSpecies(speciesId) || speciesId.startsWith('deerling') ||
		speciesId.startsWith('sawsbuck') || ZA_MEGA_SPECIES.has(speciesId as ID);
}

const CUSTOM_VISUAL_FORME_MARKERS = new Set([
	'Alt', 'Aevian', 'East-Aevian', 'Pulse', 'Azzy', 'Azzy2',
	'Spring', 'Summer', 'Autumn', 'Winter', 'Rejuv', 'Reborn', 'Perfect', 'Deso',
	'Rocky', 'Fiery', 'Icy',
]);

// Alt and Reborn profiles are selected through their base species selector.
function isVariantSelectorOnlySpecies(species: AnyObject) {
	return !!species?.baseSpecies && toID(species.baseSpecies) !== toID(species.name) &&
		/(?:^|-)(?:Alt|Reborn)$/.test(species.forme || '');
}
function isCustomSearchVisualForm(species: AnyObject) {
	if (!species || typeof species !== 'object') return false;
	const forme = species?.forme;
	if (species?.isNonstandard === 'Custom') return true;
	if (typeof forme !== 'string') return false;
	return CUSTOM_VISUAL_FORME_MARKERS.has(forme) || forme.endsWith('-Alt') ||
		[...CUSTOM_VISUAL_FORME_MARKERS].some(marker => forme.endsWith(`-${marker}`));
}

function matchesCustomSearchGroup(species: AnyObject, query: string) {
	const name = toID(species?.name);
	const forme = toID(species?.forme);
	if (query === 'rejuv') return forme === 'rejuv' || name.endsWith('rejuv');
	if (query === 'reborn') return forme === 'reborn' || name.endsWith('reborn');
	if (query === 'aevian') return forme.includes('aevian') || name.includes('aevian') ||
		forme.includes('rejuv') || name.includes('rejuv') || name === 'miloticterajuma';
	if (query === 'deso') return forme === 'deso' || name.endsWith('deso') || name === 'umbreonperfect';
	return false;
}

function isExplicitFurfrouVariantSearch(species: AnyObject, query: string) {
	return query === 'furfrou' && toID(species?.baseSpecies) === 'furfrou' && toID(species?.name) !== 'furfrou';
}

const CUSTOM_CAN_LEARN_OVERRIDES: {[speciesid: string]: {[moveid: string]: true}} = {
	meowstic: {aurasphere: true, drainingkiss: true, vacuumwave: true},
	meowsticf: {aurasphere: true, drainingkiss: true, vacuumwave: true},
	meowsticmmega: {aurasphere: true, drainingkiss: true, vacuumwave: true},
	meowsticfmega: {aurasphere: true, drainingkiss: true, vacuumwave: true},
};

/**
 * Backend for search UIs.
 */
// Verified presentation preference, not a global item alias. The legacy stone
// shares regular Golisopod's target, but does not support its Aevian form.
const MEGA_ITEM_PICKER_PREFERENCES: {[id: string]: {canonical: ID, species: ID}} = {
	megagolisopite: {canonical: 'golisopite' as ID, species: 'golisopod' as ID},
};

class DexSearch {
	static isHiddenCosmeticPattern(id: string) {
		return Dex.isSpeciesHidden(id) || VIVILLON_PATTERN_SPECIES.has(toID(id));
	}

	prependResults: SearchRow[] | null = null;
	query = '';
	itemToolFilter = 'all';

	/**
	 * Dex for the mod/generation to search.
	 */
	dex: ModdedDex = Dex;

	typedSearch: BattleTypedSearch<SearchType> | null = null;

	results: SearchRow[] | null = null;
	exactMatch = false;

	static typeTable = {
		pokemon: 1,
		type: 2,
		tier: 3,
		move: 4,
		item: 5,
		ability: 6,
		egggroup: 7,
		category: 8,
		article: 9,
	};
	static typeName = {
		pokemon: 'Pok&eacute;mon',
		type: 'Type',
		tier: 'Tiers',
		move: 'Moves',
		item: 'Items',
		ability: 'Abilities',
		egggroup: 'Egg group',
		category: 'Category',
		article: 'Article',
	};
	firstPokemonColumn: 'Tier' | 'Number' = 'Number';

	/**
	 * Column to sort by. Default is `null`, a smart sort determined by how good
	 * things are according to the base filters, falling back to dex number (for
	 * Pokemon) and name (for everything else).
	 */
	sortCol: string | null = null;
	reverseSort = false;

	/**
	 * Filters for the search result. Does not include the two base filters
	 * (format and species).
	 */
	filters: SearchFilter[] | null = null;

	constructor(searchType: SearchType | '' = '', formatid = '' as ID, species = '' as ID) {
		this.setType(searchType, formatid, species);
	}

	getTypedSearch(searchType: SearchType | '', format = '' as ID, speciesOrSet: ID | PokemonSet = '' as ID) {
		if (!searchType) return null;
		switch (searchType) {
		case 'pokemon': return new BattlePokemonSearch('pokemon', format, speciesOrSet);
		case 'item': return new BattleItemSearch('item', format, speciesOrSet);
		case 'move': return new BattleMoveSearch('move', format, speciesOrSet);
		case 'ability': return new BattleAbilitySearch('ability', format, speciesOrSet);
		case 'type': return new BattleTypeSearch('type', format, speciesOrSet);
		case 'category': return new BattleCategorySearch('category', format, speciesOrSet);
		}
		return null;
	}

	pickerOptions: { hideMegas?: boolean, hideGimmicks?: boolean, customOnly?: boolean, group?: string } = {};

	static pokemonPickerTraits(species: Species) {
		const raw = window.BattlePokedex?.[species.id] || {};
		const forms = (species.forme || '').toLowerCase().split('-');
		const pulse = forms.includes('pulse');
		const rift = forms.includes('rift');
		const mega = !pulse && !rift && (species.isMega || !!raw.isMega || forms.some(f => /^mega[xyz]?$/.test(f)));
		const core = species.requiredItems?.some(item => toID(item) === 'anomalycore');
		return {
			mega, pulse, rift, totem: isTotemSpecies(species),
			gimmick: mega || species.isPrimal || forms.includes('primal') || forms.includes('gmax') ||
				!!species.battleOnly || !!raw.battleOnly || !!core,
			regional: forms.some(f => ['alola', 'galar', 'hisui', 'paldea', 'aevian'].includes(f)),
			custom: !isExcludedFromCustomSearch(species.id) && isCustomSearchVisualForm(species),
		};
	}

	pickerMatches(id: string) {
		const species = this.dex.species.get(id);
		const traits = DexSearch.pokemonPickerTraits(species);
		const options = this.pickerOptions;
		return species.exists && !Dex.isSpeciesHidden(species.id) && !traits.totem && !(options.hideMegas && traits.mega) && !(options.hideGimmicks && traits.gimmick) &&
			!(options.customOnly && !traits.custom) &&
			(!options.group || options.group === 'all' || !!traits[options.group as 'pulse' | 'rift' | 'regional']);
	}

	filterPokemonPicker(rows: SearchRow[]): SearchRow[] {
		rows = rows.filter(row => row[0] !== 'item' || row[1] !== 'empoleonitex');
		rows = rows.filter(row => row[0] !== 'pokemon' || (!Dex.isSpeciesHidden(this.dex.species.get(row[1]).id) && !isTotemSpecies(window.BattlePokedex?.[row[1]])));
		if (this.typedSearch?.searchType !== 'pokemon') return rows;
		const options = this.pickerOptions;
		if (!options.hideMegas && !options.hideGimmicks && !options.customOnly && (!options.group || options.group === 'all')) return rows;
		const catalog = options.customOnly || (options.group && options.group !== 'all');
		if (catalog && !['type', 'ability'].includes(this.sortCol || '')) {
			// Explicit catalog browsing may reveal custom entries, just like -custom. Legality labels are unchanged.
			const query = this.query === '-custom' ? '' : this.query;
			const present = new Set(rows.filter(row => row[0] === 'pokemon').map(row => row[1]));
			const extra: SearchRow[] = [];
			for (const id of Object.keys(window.BattlePokedex || {})) {
				if (present.has(id) || isHiddenFakeSpecies(id)) continue;
				const species = this.dex.species.get(id);
				if (!this.pickerMatches(id) || (query && !toID(species.name).includes(query))) continue;
				if (this.query === '-custom' && !DexSearch.pokemonPickerTraits(species).custom) continue;
				const row: SearchRow = ['pokemon', id as ID];
				if (this.typedSearch.filter(row, this.filters || [])) extra.push(row);
			}
			rows = rows.concat(extra);
		}
		rows = dedupeSearchResults(rows.filter(row => row[0] !== 'pokemon' || this.pickerMatches(row[1])));
		if (this.sortCol && !['type', 'ability'].includes(this.sortCol)) {
			const pokemon = this.typedSearch.sort(rows.filter(row => row[0] === 'pokemon'), this.sortCol, this.reverseSort);
			rows = rows.filter(row => row[0] !== 'pokemon' && row[0] !== 'header').concat(pokemon);
		}
		return rows.filter((row, index) => {
			if (row[0] !== 'header') return true;
			for (let i = index + 1; i < rows.length && rows[i][0] !== 'header'; i++) {
				if (!['html', 'sortpokemon'].includes(rows[i][0])) return true;
			}
			return false;
		});
	}

	private dedupeItemResults(results: SearchRow[], query: string, explicitItems: string[] | null = null) {
		const unique = dedupeSearchResults(results);
		const offered = new Set(unique.filter(row => row[0] === 'item').map(row => row[1]));
		const reasons = this.typedSearch?.illegalReasons;
		const requested = toID(query || (!explicitItems && this.typedSearch?.set?.item) || '');
		const exact = MEGA_ITEM_PICKER_PREFERENCES[requested];
		const visible = unique.filter(row => {
			if (row[0] !== 'item') return true;
			// Exact legacy lookup keeps that real item, rather than another equivalent suggestion.
			if (exact?.species === this.typedSearch?.species && row[1] === exact.canonical && offered.has(requested) &&
				(reasons?.[requested] || '') === (reasons?.[exact.canonical] || '')) return false;
			const preference = MEGA_ITEM_PICKER_PREFERENCES[row[1]];
			if (!preference || preference.species !== this.typedSearch?.species || row[1] === requested ||
				explicitItems?.includes(row[1])) return true;
			return !offered.has(preference.canonical) ||
				(reasons?.[row[1]] || '') !== (reasons?.[preference.canonical] || '');
		});
		return visible.filter((row, index) => row[0] !== 'header' ||
			(index + 1 < visible.length && visible[index + 1][0] !== 'header'));
	}

	find(query: string) {
		const itemTools = (window as any).TeambuilderTools;
		if (this.typedSearch?.searchType === 'item' && itemTools) {
			const prefs = itemTools.itemData();
			const selected: string[] | null = this.itemToolFilter === 'favorites' ? prefs.favorites :
				this.itemToolFilter === 'recent' ? prefs.recent : null;
			this.query = query;
			this.results = this.typedSearch.getResults(this.filters, this.sortCol, this.reverseSort).filter(row =>
				row[0] !== 'item' ? row[0] === 'header' :
				(!selected || selected.includes(row[1])) && itemTools.itemMatches(row[1], query, this.dex));
			if (this.itemToolFilter === 'recent' && selected) {
				// Keep legality/category sections, ordering each section by last selection.
				for (let start = 0; start < this.results.length;) {
					if (this.results[start][0] !== 'item') { start++; continue; }
					let end = start + 1;
					while (end < this.results.length && this.results[end][0] === 'item') end++;
					const recentRows = this.results.slice(start, end).sort((a, b) =>
						selected.indexOf(a[1]) - selected.indexOf(b[1]));
					this.results.splice(start, end - start, ...recentRows);
					start = end;
				}
			}
			this.results = this.dedupeItemResults(this.results, query, selected);
			this.exactMatch = !!this.dex.items.get(query).exists;
			return true;
		}
		query = query.trim().toLowerCase() === '-custom' ? '-custom' : toID(query);
		if (this.query === query && this.results) {
			return false;
		}
		this.query = query;
		if (!query) {
			this.results = this.typedSearch?.getResults(this.filters, this.sortCol, this.reverseSort) || [];
		} else {
			this.results = this.textSearch(query);
		}
		if (this.typedSearch?.searchType === 'item') this.results = this.dedupeItemResults(this.results, query);
		this.results = this.filterPokemonPicker(this.results);
		if (query && ['pokemon', 'move'].includes(this.typedSearch?.searchType || '')) {
			this.results = this.sortTextResults(this.results);
		}
		return true;
	}

	/** Sort only selectable matches, retaining suggestions, groups, and legality boundaries. */
	sortTextResults(rows: SearchRow[]): SearchRow[] {
		const search = this.typedSearch!;
		const result = rows.slice();
		const column = this.sortCol;
					const key = (row: SearchRow) => {
						if (search.searchType === 'move') {
							const move = this.dex.moves.get(row[1]);
							return column === 'type' ? move.type : move.category;
						}
						const species = this.dex.species.get(row[1]);
						return column === 'type' ? species.types.join('/') : Object.values(species.abilities).join('/');
					};
		if (column) {
			for (let start = 0; start < result.length;) {
				if (result[start][0] !== search.searchType) { start++; continue; }
				const illegal = this.illegalLabel(result[start][1] as ID);
				let end = start + 1;
				while (end < result.length && result[end][0] === search.searchType &&
					this.illegalLabel(result[end][1] as ID) === illegal) end++;
				let matches = result.slice(start, end);
				if (['type', 'category', 'ability'].includes(column)) {

					matches.sort((a, b) => key(a).localeCompare(key(b)) * (this.reverseSort ? -1 : 1));
				} else {
					matches = search.sort(matches, column, this.reverseSort);
				}
				result.splice(start, end - start, ...matches);
				start = end;
			}
		}
		return [[search.searchType === 'pokemon' ? 'sortpokemon' : 'sortmove', ''], ...result];
	}

	setType(searchType: SearchType | '', format = '' as ID, speciesOrSet: ID | PokemonSet = '' as ID) {
		// invalidate caches
		this.results = null;

		if (searchType !== this.typedSearch?.searchType) {
			this.filters = null;
			this.sortCol = null;
		}
		this.typedSearch = this.getTypedSearch(searchType, format, speciesOrSet);
		if (this.typedSearch) this.dex = this.typedSearch.dex;
	}

	addFilter(entry: SearchFilter): boolean {
		if (!this.typedSearch) return false;
		let [type] = entry;
		if (this.typedSearch.searchType === 'pokemon') {
			if (type === this.sortCol) this.sortCol = null;
			if (!['type', 'move', 'ability', 'egggroup', 'tier'].includes(type)) return false;
			if (type === 'move') entry[1] = toID(entry[1]);
			if (!this.filters) this.filters = [];
			this.results = null;
			for (const filter of this.filters) {
				if (filter[0] === type && filter[1] === entry[1]) {
					return true;
				}
			}
			this.filters.push(entry);
			return true;
		} else if (this.typedSearch.searchType === 'move') {
			if (type === this.sortCol) this.sortCol = null;
			if (!['type', 'category', 'pokemon'].includes(type)) return false;
			if (type === 'pokemon') entry[1] = toID(entry[1]);
			if (!this.filters) this.filters = [];
			this.filters.push(entry);
			this.results = null;
			return true;
		}
		return false;
	}

	removeFilter(entry?: SearchFilter): boolean {
		if (!this.filters) return false;
		if (entry) {
			const filterid = entry.join(':');
			let deleted: string[] | null = null;
			// delete specific filter
			for (let i = 0; i < this.filters.length; i++) {
				if (filterid === this.filters[i].join(':')) {
					deleted = this.filters[i];
					this.filters.splice(i, 1);
					break;
				}
			}
			if (!deleted) return false;
		} else {
			this.filters.pop();
		}
		if (!this.filters.length) this.filters = null;
		this.results = null;
		return true;
	}

	toggleSort(sortCol: string) {
		if (this.sortCol === sortCol) {
			if (!this.reverseSort) {
				this.reverseSort = true;
			} else {
				this.sortCol = null;
				this.reverseSort = false;
			}
		} else {
			this.sortCol = sortCol;
			this.reverseSort = false;
		}
		this.results = null;
	}

	filterLabel(filterType: string) {
		if (this.typedSearch && this.typedSearch.searchType !== filterType) {
			return 'Filter';
		}
		return null;
	}
	illegalLabel(id: ID) {
		return this.typedSearch?.illegalReasons?.[id] || null;
	}

	getTier(species: Species) {
		return this.typedSearch?.getTier(species) || '';
	}

	textSearch(query: string): SearchRow[] {
		const customOnly = query === '-custom' && this.typedSearch?.searchType === 'pokemon';
		query = toID(query);
		const customSpeciesQuery = query;
		window.ensureCustomDataPatches?.();

		this.exactMatch = false;
		let searchType: SearchType | '' = this.typedSearch?.searchType || '';

		// Exact normalized character names reveal their credited moves while preserving
		// the current move filters and the existing per-species legality labels.
		if (searchType === 'move' && query) {
			const credited = Object.keys(window.BattleMovedex || {}).filter(id =>
				(window.BattleMovedex[id] as AnyObject).signatureCharacters?.includes(query)
			) as ID[];
			if (credited.length) {
				this.typedSearch!.getResults(this.filters, this.sortCol, this.reverseSort);
				const rows = credited.map(id => ['move', id] as SearchRow)
					.filter(row => this.typedSearch!.filter(row, this.filters || []));
				rows.sort((a, b) => Number(!!this.illegalLabel(a[1] as ID)) - Number(!!this.illegalLabel(b[1] as ID)) ||
					this.dex.moves.get(a[1]).name.localeCompare(this.dex.moves.get(b[1]).name));
				this.exactMatch = true;
				return this.results = [['header', 'Moves'], ...rows];
			}
		}
		let customVisualSpecies: ID[] = [];
		if (searchType === 'pokemon') {
			window.ensureCustomSpecies?.();
			customVisualSpecies = Object.keys(window.BattlePokedex || {}).filter(id => {
				const species = this.dex.species.get(id);
				if (customOnly) {
					// Read the effective catalog, including selector-only and battle forms,
					// rather than relying on the upstream text index or name substrings.
					return species.exists && !isExcludedFromCustomSearch(id) &&
						isCustomSearchVisualForm(species) &&
						this.typedSearch!.filter(['pokemon', id as ID], this.filters || []);
				}
				if (id === 'gardevoirvoid' && (customOnly || customSpeciesQuery === 'alt')) return false;
				if (isExcludedFromCustomSearch(id)) return false;
				// Explicit -custom searches reveal hidden stored variants, but never
				// expose battle-only visual destinations used by abilities.
				if (isBattleOnlyVisualSpecies(id) || isVariantSelectorOnlySpecies(species)) return false;
				const isCustomSpecies = isCustomSearchVisualForm(species) ||
					isExplicitFurfrouVariantSearch(species, customSpeciesQuery);
				return isCustomSpecies && (customOnly || matchesCustomSearchGroup(species, customSpeciesQuery) ||
					toID(species.name) === customSpeciesQuery ||
					window.getCustomVisualFamilyId?.(species) === customSpeciesQuery);
			}) as ID[];
		}
		if (customOnly) {
			customVisualSpecies.sort((a, b) => this.dex.species.get(a).name.localeCompare(this.dex.species.get(b).name));
			this.exactMatch = true;
			this.results = [
				['header', 'Custom Pokémon and variants'],
				['html', '<p>Custom species, skins, and battle forms. Battle-only forms are for inspection; use the listed starting species and required item. Format legality still applies.</p>'],
				...customVisualSpecies.map(id => ['pokemon', id] as SearchRow),
			];
			if (!customVisualSpecies.length) this.results.push(['html', '<p>No custom species match the current filters.</p>']);
			return this.results;
		}

		// If searchType exists, we're searching mainly for results of that type.
		// We'll still search for results of other types, but those results
		// will only be used to filter results for that type.
		let searchTypeIndex = (searchType ? DexSearch.typeTable[searchType] : -1);

		/** searching for "Psychic type" will make the type come up over the move */
		let qFilterType: 'type' | '' = '';
		if (query.slice(-4) === 'type') {
			if (query.slice(0, -4) in window.BattleTypeChart) {
				query = query.slice(0, -4);
				qFilterType = 'type';
			}
		}

		// i represents the location of the search index we're looking at
		let i = DexSearch.getClosest(query);
		this.exactMatch = (BattleSearchIndex[i][0] === query);
		if (customVisualSpecies.length) this.exactMatch = true;

		// Even with output buffer buckets, we make multiple passes through
		// the search index. searchPasses is a queue of which pass we're on:
		// [passType, i, query]

		// By doing an alias pass after the normal pass, we ensure that
		// mid-word matches only display after start matches.
		let passType: SearchPassType | '' = '';
		/**
		 * pass types:
		 * * '': time to pop the next pass off the searchPasses queue
		 * * 'normal': start at i and stop when results no longer start with query
		 * * 'alias': like normal, but output aliases instead of non-alias results
		 * * 'fuzzy': start at i and stop when you have two results
		 * * 'exact': like normal, but stop at i
		 */
		type SearchPassType = 'normal' | 'alias' | 'fuzzy' | 'exact';
		/**
		 * [passType, i, query]
		 *
		 * i = index of BattleSearchIndex to start from
		 *
		 * By doing an alias pass after the normal pass, we ensure that
		 * mid-word matches only display after start matches.
		 */
		type SearchPass = [SearchPassType, number, string];
		let searchPasses: SearchPass[] = [['normal', i, query]];

		// For performance reasons, only do an alias pass if query is at
		// least 2 chars long
		if (query.length > 1) searchPasses.push(['alias', i, query]);

		// If the query matches an official alias in BattleAliases: These are
		// different from the aliases in the search index and are given
		// higher priority. We'll do a normal pass through the index with
		// the alias text before any other passes.
		let queryAlias;
		if (query in BattleAliases) {
			if (['sub', 'tr'].includes(query) || toID(BattleAliases[query]).slice(0, query.length) !== query) {
				queryAlias = toID(BattleAliases[query]);
				let aliasPassType: SearchPassType = (queryAlias === 'hiddenpower' ? 'exact' : 'normal');
				searchPasses.unshift([aliasPassType, DexSearch.getClosest(queryAlias), queryAlias]);
			}
			this.exactMatch = true;
		}

		// If there are no matches starting with query: Do a fuzzy match pass
		// Fuzzy matches will still be shown after alias matches
		if (!this.exactMatch && BattleSearchIndex[i][0].substr(0, query.length) !== query) {
			// No results start with this. Do a fuzzy match pass.
			let matchLength = query.length - 1;
			if (!i) i++;
			while (matchLength &&
				BattleSearchIndex[i][0].substr(0, matchLength) !== query.substr(0, matchLength) &&
				BattleSearchIndex[i - 1][0].substr(0, matchLength) !== query.substr(0, matchLength)) {
				matchLength--;
			}
			let matchQuery = query.substr(0, matchLength);
			while (i >= 1 && BattleSearchIndex[i - 1][0].substr(0, matchLength) === matchQuery) i--;
			searchPasses.push(['fuzzy', i, '']);
		}

		// We split the output buffers into 8 buckets.
		// Bucket 0 is usually unused, and buckets 1-7 represent
		// pokemon, types, moves, etc (see typeTable).

		// When we're done, the buffers are concatenated together to form
		// our results, with each buffer getting its own header, unlike
		// multiple-pass results, which have no header.

		// Notes:
		// - if we have a searchType, that searchType's buffer will be on top
		let bufs: SearchRow[][] = [[], [], [], [], [], [], [], [], [], []];
		let topbufIndex = -1;

		let count = 0;
		let nearMatch = false;

		/** [type, id, typeIndex] */
		let instafilter: [SearchType, ID, number] | null = null;
		let instafilterSort = [0, 1, 2, 5, 4, 3, 6, 7, 8];
		let illegal = this.typedSearch?.illegalReasons;

		// We aren't actually looping through the entirety of the searchIndex
		for (i = 0; i < BattleSearchIndex.length; i++) {
			if (!passType) {
				let searchPass = searchPasses.shift();
				if (!searchPass) break;
				passType = searchPass[0];
				i = searchPass[1];
				query = searchPass[2];
			}

			let entry = BattleSearchIndex[i];
			let id = entry[0];
			let type = entry[1];

			if (!id) break;
			const disciplineSearch = this.typedSearch?.species === 'alakazamrejuv' ||
				(this.typedSearch?.species === 'alakazam' && toID(this.typedSearch.set?.ability) === 'aeviandiscipline');
			if (type === 'move' && (
				id.startsWith('hiddenpower') ||
				toID(BattleAliases[id] || '').startsWith('hiddenpower') ||
				query === 'hp' || query.startsWith('hiddenpower')
			) && !disciplineSearch) continue;

			if (passType === 'fuzzy') {
				// fuzzy match pass; stop after 2 results
				if (count >= 2) {
					passType = '';
					continue;
				}
				nearMatch = true;
			} else if (passType === 'exact') {
				// exact pass; stop after 1 result
				if (count >= 1) {
					passType = '';
					continue;
				}
			} else if (id.substr(0, query.length) !== query) {
				// regular pass, time to move onto our next match
				passType = '';
				continue;
			}

			if (entry.length > 2) {
				// alias entry
				if (passType !== 'alias') continue;
			} else {
				// normal entry
				if (passType === 'alias') continue;
			}

			let typeIndex = DexSearch.typeTable[type];

			// For performance, with a query length of 1, we only fill the first bucket
			if (query.length === 1 && typeIndex !== (searchType ? searchTypeIndex : 1)) continue;

			// For pokemon queries, accept types/tier/abilities/moves/eggroups as filters
			if (searchType === 'pokemon' && (typeIndex === 5 || typeIndex > 7)) continue;
			// For move queries, accept types/categories as filters
			if (searchType === 'move' && ((typeIndex !== 8 && typeIndex > 4) || typeIndex === 3)) continue;
			// For move queries in the teambuilder, don't accept pokemon as filters
			if (searchType === 'move' && illegal && typeIndex === 1) continue;
			// For ability/item queries, don't accept anything else as a filter
			if ((searchType === 'ability' || searchType === 'item') && typeIndex !== searchTypeIndex) continue;
			// Query was a type name followed 'type'; only show types
			if (qFilterType === 'type' && typeIndex !== 2) continue;
			// hardcode cases of duplicate non-consecutive aliases
			if ((id === 'megax' || id === 'megay') && 'mega'.startsWith(query)) continue;

			let matchStart = 0;
			let matchEnd = 0;
			if (passType === 'alias') {
				// alias entry
				// [aliasid, type, originalid, matchStart, originalindex]
				matchStart = entry[3]!;
				let originalIndex = entry[2]!;
				if (matchStart) {
					matchEnd = matchStart + query.length;
					matchStart += (BattleSearchIndexOffset[originalIndex][matchStart] || '0').charCodeAt(0) - 48;
					matchEnd += (BattleSearchIndexOffset[originalIndex][matchEnd - 1] || '0').charCodeAt(0) - 48;
				}
				id = BattleSearchIndex[originalIndex][0];
			} else {
				matchEnd = query.length;
				if (matchEnd) matchEnd += (BattleSearchIndexOffset[i][matchEnd - 1] || '0').charCodeAt(0) - 48;
			}

			// some aliases are substrings
			if (queryAlias === id && query !== id) continue;
			if (
				type === 'pokemon' &&
				(VIVILLON_PATTERN_SPECIES.has(id) || isCAPSpecies(id) || isHiddenFakeSpecies(id) || isBattleOnlyVisualSpecies(id) ||
					isVariantSelectorOnlySpecies(this.dex.species.get(id)) ||
					(isHiddenTeamBuilderSpecies(id) && id !== query &&
					!(query === 'furfrou' && id.startsWith('furfrou'))))
			) continue;

			if (searchType && searchTypeIndex !== typeIndex) {
				// This is a filter, set it as an instafilter candidate
				if (!instafilter || instafilterSort[typeIndex] < instafilterSort[instafilter[2]]) {
					instafilter = [type, id, typeIndex];
				}
			}

			// show types above Arceus formes
			if (topbufIndex < 0 && searchTypeIndex < 2 && passType === 'alias' && !bufs[1].length && bufs[2].length) {
				topbufIndex = 2;
			}

			if (illegal && typeIndex === searchTypeIndex) {
				// Always show illegal results under legal results.
				// This is done by putting legal results (and the type header)
				// in bucket 0, and illegal results in the searchType's bucket.
				// searchType buckets are always on top (but under bucket 0), so
				// illegal results will be seamlessly right under legal results.
				if (!bufs[typeIndex].length && !bufs[0].length) {
					bufs[0] = [['header', DexSearch.typeName[type]]];
				}
				if (!(id in illegal)) typeIndex = 0;
			} else {
				if (!bufs[typeIndex].length) {
					bufs[typeIndex] = [['header', DexSearch.typeName[type]]];
				}
			}

			// don't match duplicate aliases
			let curBufLength = (passType === 'alias' && bufs[typeIndex].length);
			if (curBufLength && bufs[typeIndex][curBufLength - 1][1] === id) continue;

			bufs[typeIndex].push([type, id, matchStart, matchEnd]);

			count++;
		}

		if (instafilter && count < 20) {
			// Result count is less than 20, so we can instafilter
			bufs.push(this.instafilter(searchType, instafilter[0], instafilter[1]));
		}

		if (customVisualSpecies.length) {
			const existing = new Set<string>();
			for (const buf of bufs) {
				for (const row of buf) {
					if (row[0] === 'pokemon') existing.add(row[1]);
				}
			}
			const rows: SearchRow[] = [];
			for (const id of customVisualSpecies) {
				if (!existing.has(id)) rows.push(['pokemon', id, 0, customSpeciesQuery.length]);
			}
			if (rows.length) {
				if (!bufs[1].length) bufs[1] = [['header', DexSearch.typeName.pokemon]];
				bufs[1].splice(1, 0, ...rows);
			}
		}

		// Custom abilities may be patched into BattleAbilities after the static search
		// index was generated. Match their names and explicitly declared ability components.
		if (!searchType || searchType === 'pokemon' || searchType === 'ability') {
			const abilityRows: ['ability', ID, number?, number?][] = [];
			const abilitySearchQuery = customSpeciesQuery;
			if (abilitySearchQuery) {
				for (const id in (window.BattleAbilities || {})) {
					const ability = this.dex.abilities.get(id as ID);
					if (!ability.name) continue;
					const nameId = toID(ability.name);
					const nameMatch = nameId.indexOf(abilitySearchQuery);
					const effectMatch = Dex.getAbilityEffects(id as ID).has(abilitySearchQuery as ID);
					if (nameMatch < 0 && !effectMatch) continue;
					abilityRows.push([
						'ability', id as ID, nameMatch < 0 ? 0 : nameMatch,
						nameMatch < 0 ? 0 : nameMatch + abilitySearchQuery.length,
					]);
				}
			}
			if (abilityRows.length) {
				const abilityTypeIndex = DexSearch.typeTable.ability;
				if (!bufs[abilityTypeIndex].length) bufs[abilityTypeIndex] = [['header', DexSearch.typeName.ability]];
				const existing = new Set<string>(bufs[abilityTypeIndex].filter(row => row[0] === 'ability').map(row => row[1]));
				const newAbilityRows = abilityRows.filter(row => !existing.has(row[1]));
				bufs[abilityTypeIndex].push(...newAbilityRows);
				if (searchType === 'pokemon' && !instafilter && newAbilityRows.length) {
					instafilter = ['ability', newAbilityRows[0][1], abilityTypeIndex];
				}
			}
		}

		// Search the custom Terajuma moves missing from the static index.
		if ((!searchType || searchType === 'move') && customSpeciesQuery) {
			for (const id of ['atlantiswall', 'tailsmash'] as ID[]) {
				const nameId = toID(this.dex.moves.get(id).name);
				const matchStart = nameId.indexOf(customSpeciesQuery);
				let alreadyShown = false;
				for (const buf of bufs) {
					for (const entry of buf) {
						if (entry[0] === 'move' && entry[1] === id) alreadyShown = true;
					}
				}
				if (matchStart < 0 || alreadyShown) continue;
				const row: SearchRow = ['move', id, matchStart, matchStart + customSpeciesQuery.length];
				const index = DexSearch.typeTable.move;
				if (searchType === 'move' && illegal && !(id in illegal)) {
					if (!bufs[0].length) bufs[0] = [['header', DexSearch.typeName.move]];
					bufs[0].push(row);
				} else {
					if (!bufs[index].length) bufs[index] = [['header', DexSearch.typeName.move]];
					bufs[index].push(row);
				}
			}
		}

		let topbuf: SearchRow[] = [];
		if (nearMatch) {
			topbuf = [['html', `<em>No exact match found. The closest matches alphabetically are:</em>`]];
		}
		if (topbufIndex >= 0) {
			topbuf = topbuf.concat(bufs[topbufIndex]);
			bufs[topbufIndex] = [];
		}
		if (searchTypeIndex >= 0) {
			topbuf = topbuf.concat(bufs[0]);
			topbuf = topbuf.concat(bufs[searchTypeIndex]);
			bufs[searchTypeIndex] = [];
			bufs[0] = [];
		}

		this.results = dedupeSearchResults(Array.prototype.concat.apply(topbuf, bufs));
		return this.results;
	}
	private instafilter(searchType: SearchType | '', fType: SearchType, fId: ID): SearchRow[] {
		let buf: SearchRow[] = [];
		let illegalBuf: SearchRow[] = [];
		let illegal = this.typedSearch?.illegalReasons;
		if (searchType === 'pokemon') {
			switch (fType) {
			case 'type':
				let type = fId.charAt(0).toUpperCase() + fId.slice(1) as TypeName;
				buf.push(['header', `${type}-type Pok&eacute;mon`]);
				for (let id in BattlePokedex) {
					if (isHiddenTeamBuilderSpecies(id) || !BattlePokedex[id].types) continue;
					if (this.dex.species.get(id).types.includes(type)) {
						(illegal && id in illegal ? illegalBuf : buf).push(['pokemon', id as ID]);
					}
				}
				break;
			case 'ability':
				let ability = Dex.abilities.get(fId).name;
				buf.push(['header', `${ability} Pok&eacute;mon`]);
				for (let id in BattlePokedex) {
					if (isHiddenTeamBuilderSpecies(id)) continue;
					if (!BattlePokedex[id].abilities) continue;
					if (Dex.hasAbilityEffect(this.dex.species.get(id), ability)) {
						(illegal && id in illegal ? illegalBuf : buf).push(['pokemon', id as ID]);
					}
				}
				break;
			}
		} else if (searchType === 'move') {
			switch (fType) {
			case 'type':
				let type = fId.charAt(0).toUpperCase() + fId.slice(1);
				buf.push(['header', `${type}-type moves`]);
				for (let id in BattleMovedex) {
					if (BattleMovedex[id].type === type) {
						(illegal && id in illegal ? illegalBuf : buf).push(['move', id as ID]);
					}
				}
				break;
			case 'category':
				let category = fId.charAt(0).toUpperCase() + fId.slice(1);
				buf.push(['header', `${category} moves`]);
				for (let id in BattleMovedex) {
					if (BattleMovedex[id].category === category) {
						(illegal && id in illegal ? illegalBuf : buf).push(['move', id as ID]);
					}
				}
				break;
			}
		}
		return [...buf, ...illegalBuf];
	}

	static getClosest(query: string) {
		// binary search through the index!
		let left = 0;
		let right = BattleSearchIndex.length - 1;
		while (right > left) {
			let mid = Math.floor((right - left) / 2 + left);
			if (BattleSearchIndex[mid][0] === query && (mid === 0 || BattleSearchIndex[mid - 1][0] !== query)) {
				// that's us
				return mid;
			} else if (BattleSearchIndex[mid][0] < query) {
				left = mid + 1;
			} else {
				right = mid - 1;
			}
		}
		if (left >= BattleSearchIndex.length - 1) left = BattleSearchIndex.length - 1;
		else if (BattleSearchIndex[left + 1][0] && BattleSearchIndex[left][0] < query) left++;
		if (left && BattleSearchIndex[left - 1][0] === query) left--;
		return left;
	}
}

abstract class BattleTypedSearch<T extends SearchType> {
	searchType: T;
	/**
	 * Dex for the mod/generation to search.
	 */
	dex: ModdedDex = Dex;
	/**
	 * Format is the first of two base filters. It constrains results to things
	 * legal in the format, and affects the default sort.
	 *
	 * This string specifically normalizes out generation number and the words
	 * "Doubles" and "Let's Go" from the name.
	 */
	format = '' as ID;
	/**
	 * `species` is the second of two base filters. It constrains results to
	 * things that species can use, and affects the default sort.
	 */
	species = '' as ID;
	/**
	 * `set` is a pseudo-base filter; it has minor effects on move sorting.
	 * (Abilities/items can affect what moves are sorted as usable.)
	 */
	set: PokemonSet | null = null;

	protected formatType: 'doubles' | 'bdsp' | 'bdspdoubles' | 'letsgo' | 'metronome' | 'natdex' | 'nfe' |
	'ssdlc1' | 'ssdlc1doubles' | 'predlc' | 'predlcdoubles' | 'predlcnatdex' | 'svdlc1' | 'svdlc1doubles' |
	'svdlc1natdex' | 'stadium' | 'lc' | null = null;
	protected isFieldFormat = false;
	protected unrestrictedCatalog = false;

	/**
	 * Cached copy of what the results list would be with only base filters
	 * (i.e. with an empty `query` and `filters`)
	 */
	baseResults: SearchRow[] | null = null;
	/**
	 * Cached copy of all results not in `baseResults` - mostly in case a user
	 * is wondering why a specific result isn't showing up.
	 */
	baseIllegalResults: SearchRow[] | null = null;
	illegalReasons: {[id: string]: string} | null = null;
	results: SearchRow[] | null = null;

	protected readonly sortRow: SearchRow | null = null;

	constructor(searchType: T, format = '' as ID, speciesOrSet: ID | PokemonSet = '' as ID) {
		this.searchType = searchType;

		this.baseResults = null;
		this.baseIllegalResults = null;
		const bareGeneration = /^gen\d$/.test(format);
		if (format.slice(0, 3) === 'gen') {
			const gen = (Number(format.charAt(3)) || 6);
			format = (format.slice(4) || 'customgame') as ID;
			this.dex = Dex.forGen(gen);
		} else if (!format) {
			this.dex = Dex;
		}
		this.unrestrictedCatalog = !format || bareGeneration || format === 'customgame';
		if (format.startsWith('dlc1') && this.dex.gen === 8) {
			if (format.includes('doubles')) {
				this.formatType = 'ssdlc1doubles';
			} else {
				this.formatType = 'ssdlc1';
			}
			format = format.slice(4) as ID;
		}
		if (format.startsWith('predlc')) {
			if (format.includes('doubles') && !format.includes('nationaldex')) {
				this.formatType = 'predlcdoubles';
			} else if (format.includes('nationaldex')) {
				this.formatType = 'predlcnatdex';
			} else {
				this.formatType = 'predlc';
			}
			format = format.slice(6) as ID;
		}
		if (format.startsWith('dlc1') && this.dex.gen === 9) {
			if (format.includes('doubles') && !format.includes('nationaldex')) {
				this.formatType = 'svdlc1doubles';
			} else if (format.includes('nationaldex')) {
				this.formatType = 'svdlc1natdex';
			} else {
				this.formatType = 'svdlc1';
			}
			format = format.slice(4) as ID;
		}
		if (format.startsWith('stadium')) {
			this.formatType = 'stadium';
			format = format.slice(7) as ID;
			if (!format) format = 'ou' as ID;
		}
		if (format.startsWith('vgc')) this.formatType = 'doubles';
		if (format === 'vgc2020') this.formatType = 'ssdlc1doubles';
		if (format === 'vgc2023regulationd') this.formatType = 'predlcdoubles';
		if (format === 'vgc2023regulatione') this.formatType = 'svdlc1doubles';
		if (format.includes('bdsp')) {
			if (format.includes('doubles')) {
				this.formatType = 'bdspdoubles';
			} else {
				this.formatType = 'bdsp';
			}
			format = format.slice(4) as ID;
			this.dex = Dex.mod('gen8bdsp' as ID);
		}
		if (format === 'partnersincrime') this.formatType = 'doubles';
		if (format.startsWith('ffa') || format === 'freeforall') this.formatType = 'doubles';
		if (format.includes('letsgo')) {
			this.formatType = 'letsgo';
			this.dex = Dex.mod('gen7letsgo' as ID);
		}
		this.isFieldFormat = format.includes('field') || format.includes('arena') || format.includes('board') ||
			format.includes('terrain') || format.includes('cavern') || format.includes('surface') || format.includes('underwater') || format.includes('midnightzone');
		if (format.includes('nationaldex') || format.startsWith('nd') || format.includes('natdex') || this.isFieldFormat){
			format = 'natdex' as ID;
			this.formatType = 'natdex';
			if (!format) format = 'ou' as ID;
		}
		if (format.includes('doubles') && this.dex.gen > 4 && !this.formatType) this.formatType = 'doubles';
		if (this.formatType === 'letsgo') format = format.slice(6) as ID;
		if (format.includes('metronome')) {
			this.formatType = 'metronome';
		}
		if (format.endsWith('nfe')) {
			format = format.slice(3) as ID;
			this.formatType = 'nfe';
			if (!format) format = 'ou' as ID;
		}
		if ((format.endsWith('lc') || format.startsWith('lc')) && format !== 'caplc' && !this.formatType) {
			this.formatType = 'lc';
			format = 'lc' as ID;
		}
		if (format.endsWith('draft')) format = format.slice(0, -5) as ID;
		this.format = format;
		this.species = '' as ID;
		this.set = null;
		if (typeof speciesOrSet === 'string') {
			if (speciesOrSet) this.species = speciesOrSet;
		} else {
			this.set = speciesOrSet as PokemonSet;
			this.species = toID(this.set.species);
		}
		if (!searchType || !this.set) return;
	}
	getResults(filters?: SearchFilter[] | null, sortCol?: string | null, reverseSort?: boolean): SearchRow[] {
		if (sortCol === 'type') {
			return [this.sortRow!, ...BattleTypeSearch.prototype.getDefaultResults.call(this)];
		} else if (sortCol === 'category') {
			return [this.sortRow!, ...BattleCategorySearch.prototype.getDefaultResults.call(this)];
		} else if (sortCol === 'ability') {
			return [this.sortRow!, ...BattleAbilitySearch.prototype.getDefaultResults.call(this)];
		}

		if (!this.baseResults) {
			this.baseResults = this.getBaseResults();
		}

		if (!this.baseIllegalResults) {
			const legalityFilter: {[id: string]: 1} = {};
			for (const [resultType, value] of this.baseResults) {
				if (resultType === this.searchType) legalityFilter[value] = 1;
			}
			this.baseIllegalResults = [];
			this.illegalReasons = {};

			for (const id in this.getTable()) {
				if (this.searchType === 'pokemon') {
					const species = this.dex.species.get(id);
					const baseSpeciesId = toID(species.baseSpecies);
					// Profile/custom visual forms use the legal base species' format
					// slot, while battle-only destinations remain hidden and invalid.
					if (baseSpeciesId !== id && !isBattleOnlyVisualSpecies(id) &&
						isCustomSearchVisualForm(species) && baseSpeciesId in legalityFilter) {
						continue;
					}
				}
				if (this.searchType === 'pokemon' && isHiddenTeamBuilderSpecies(id)) continue;
				if (!(id in legalityFilter)) {
					this.baseIllegalResults.push([this.searchType, id as ID]);
					this.illegalReasons[id] = 'Illegal';
				}
			}
		}

		let results: SearchRow[];
		let illegalResults: SearchRow[] | null;

		if (filters) {
			results = [];
			illegalResults = [];
			for (const result of this.baseResults) {
				if (this.filter(result, filters)) {
					if (results.length && result[0] === 'header' && results[results.length - 1][0] === 'header') {
						results[results.length - 1] = result;
					} else {
						results.push(result);
					}
				}
			}
			if (results.length && results[results.length - 1][0] === 'header') {
				results.pop();
			}
			for (const result of this.baseIllegalResults) {
				if (this.filter(result, filters)) {
					illegalResults.push(result);
				}
			}
		} else {
			results = [...this.baseResults];
			illegalResults = null;
		}

		if (sortCol) {
			results = results.filter(([rowType]) => rowType === this.searchType);
			results = this.sort(results, sortCol, reverseSort);
			if (illegalResults) {
				illegalResults = illegalResults.filter(([rowType]) => rowType === this.searchType);
				illegalResults = this.sort(illegalResults, sortCol, reverseSort);
			}
		}

		if (this.sortRow) {
			results = [this.sortRow, ...results];
		}
		if (illegalResults && illegalResults.length) {
			results = [...results, ['header', "Illegal results"], ...illegalResults];
		}
		return results;
	}
	protected firstLearnsetid(speciesid: ID) {
		let table = BattleTeambuilderTable;
		if (this.formatType?.startsWith('bdsp')) table = table['gen8bdsp'];
		if (this.formatType === 'letsgo') table = table['gen7letsgo'];
		if (speciesid in table.learnsets) return speciesid;
		const species = this.dex.species.get(speciesid);
		if (!species.exists) return '' as ID;

		let baseLearnsetid = toID(species.baseSpecies);
		if (typeof species.battleOnly === 'string' && species.battleOnly !== species.baseSpecies) {
			baseLearnsetid = toID(species.battleOnly);
		}
		if (baseLearnsetid in table.learnsets) return baseLearnsetid;
		return '' as ID;
	}
	protected nextLearnsetid(learnsetid: ID, speciesid: ID) {
		if (learnsetid === 'lycanrocdusk' || (speciesid === 'rockruff' && learnsetid === 'rockruff')) {
			return 'rockruffdusk' as ID;
		}
		const lsetSpecies = this.dex.species.get(learnsetid);
		if (!lsetSpecies.exists) return '' as ID;

		if (lsetSpecies.id === 'gastrodoneast') return 'gastrodon' as ID;
		if (lsetSpecies.id === 'pumpkaboosuper') return 'pumpkaboo' as ID;
		if (lsetSpecies.id === 'sinisteaantique') return 'sinistea' as ID;
		if (lsetSpecies.id === 'tatsugiristretchy') return 'tatsugiri' as ID;

		const next = lsetSpecies.battleOnly || lsetSpecies.changesFrom || lsetSpecies.prevo;
		if (next) return toID(next);

		return '' as ID;
	}
	protected canLearn(speciesid: ID, moveid: ID) {
		if (this.dex.gen >= 9 && speciesid === 'umbreon' && moveid === 'radiantassault') {
			return toID(this.set?.ability) === 'ascendance';
		}
		if (this.dex.gen >= 9 && Dex.getGen9MoveRemovals(speciesid).includes(moveid)) return false;
		const move = this.dex.moves.get(moveid);
		if (['politoed','politoedrejuv'].includes(speciesid) && toID(this.set?.ability) !== 'aevianking' && AEVIAN_KING_MOVE_SOURCES[moveid] && !AEVIAN_KING_ORDINARY_MOVES.includes(moveid)) return false;
		if (['poliwrath','poliwrathrejuv'].includes(speciesid) && toID(this.set?.ability) !== 'aevianascendance' && AEVIAN_ASCENDANCE_MOVE_SOURCES[moveid] && !AEVIAN_ASCENDANCE_ORDINARY_MOVES.includes(moveid)) return false;
		if (['galvantula','galvantularejuv'].includes(speciesid) && toID(this.set?.ability) !== 'aevianweb' && AEVIAN_WEB_MOVE_SOURCES[moveid] && !AEVIAN_WEB_ORDINARY_MOVES.includes(moveid)) return false;
		if (['politoed','politoedrejuv'].includes(speciesid) && toID(this.set?.ability) === 'aevianking' && this.dex.gen >= 9 && AEVIAN_KING_MOVE_SOURCES[moveid]) return true;
		if (['poliwrath','poliwrathrejuv'].includes(speciesid) && toID(this.set?.ability) === 'aevianascendance' && this.dex.gen >= 9 && AEVIAN_ASCENDANCE_MOVE_SOURCES[moveid]) return true;
		if (['galvantula','galvantularejuv'].includes(speciesid) && toID(this.set?.ability) === 'aevianweb' && this.dex.gen >= 9 && AEVIAN_WEB_MOVE_SOURCES[moveid]) return true;
		const species = this.dex.species.get(speciesid);
		if (species.id === 'alakazamrejuv' || (species.id === 'alakazam' && toID(this.set?.ability) === 'aeviandiscipline')) {
			return AEVIAN_DISCIPLINE_MOVES.includes(moveid);
		}
		if ((species.id === 'sigilyphrejuv' ||
			(species.id === 'sigilyph' && toID(this.set?.ability) === 'aeviangrief'))) {
			return AEVIAN_GRIEF_MOVE_IDS.includes(moveid);
		}
		if (
			CUSTOM_CAN_LEARN_OVERRIDES[speciesid]?.[moveid] ||
			CUSTOM_CAN_LEARN_OVERRIDES[toID(species.baseSpecies)]?.[moveid]
		) {
			return true;
		}
		const gen = this.dex.gen;
		let genChar = `${gen}`;
		if (
			this.format.startsWith('vgc') ||
			this.format.startsWith('bss') ||
			this.format.startsWith('battlespot') ||
			this.format.startsWith('battlestadium') ||
			this.format.startsWith('battlefestival') ||
			(this.dex.gen === 9 && this.formatType !== 'natdex' && !this.unrestrictedCatalog)
		) {
			if (gen === 9) {
				genChar = 'a';
			} else if (gen === 8) {
				genChar = 'g';
			} else if (gen === 7) {
				genChar = 'q';
			} else if (gen === 6) {
				genChar = 'p';
			}
		}
		const rejectsNonstandardMove = (
			this.formatType === 'natdex' && move.isNonstandard && move.isNonstandard !== 'Past'
		);
		let learnsetid = this.firstLearnsetid(speciesid);
		while (learnsetid) {
			let table = BattleTeambuilderTable;
			if (this.formatType?.startsWith('bdsp')) table = table['gen8bdsp'];
			if (this.formatType === 'letsgo') table = table['gen7letsgo'];
			let learnset = table.learnsets[learnsetid];
			if (learnset && (moveid in learnset)) {
				const sources = learnset[moveid];
				if (sources.includes('c') && sources.includes(`${gen}`)) return true;
				if (!rejectsNonstandardMove && (!this.format.startsWith('tradebacks') ? sources.includes(genChar) :
					sources.includes(genChar) || (sources.includes(`${gen + 1}`) && move.gen === gen))) {
					return true;
				}
			}
			learnsetid = this.nextLearnsetid(learnsetid, speciesid);
		}
		return false;
	}
	getTier(pokemon: Species) {
		if (this.formatType === 'metronome') {
			return pokemon.num >= 0 ? String(pokemon.num) : pokemon.tier;
		}
		let table = window.BattleTeambuilderTable;
		const gen = this.dex.gen;
		const tableKey = this.formatType === 'doubles' ? `gen${gen}doubles` :
			this.formatType === 'letsgo' ? 'gen7letsgo' :
			this.formatType === 'bdsp' ? 'gen8bdsp' :
			this.formatType === 'bdspdoubles' ? 'gen8bdspdoubles' :
			this.formatType === 'nfe' ? `gen${gen}nfe` :
			this.formatType === 'lc' ? `gen${gen}lc` :
			this.formatType === 'ssdlc1' ? 'gen8dlc1' :
			this.formatType === 'ssdlc1doubles' ? 'gen8dlc1doubles' :
			this.formatType === 'predlc' ? 'gen9predlc' :
			this.formatType === 'predlcdoubles' ? 'gen9predlcdoubles' :
			this.formatType === 'predlcnatdex' ? 'gen9predlcnatdex'  :
			this.formatType === 'svdlc1' ? 'gen9dlc1' :
			this.formatType === 'svdlc1doubles' ? 'gen9dlc1doubles' :
			this.formatType === 'svdlc1natdex' ? 'gen9dlc1natdex' :
			this.formatType === 'natdex' ? `gen${gen}natdex` :
			this.formatType === 'stadium' ? `gen${gen}stadium${gen > 1 ? gen : ''}` :
			`gen${gen}`;
		if (table && table[tableKey]) {
			table = table[tableKey];
		}
		if (!table) return pokemon.tier;

		let id = pokemon.id;
		if (id in table.overrideTier) {
			return table.overrideTier[id];
		}
		if (id.slice(-5) === 'totem' && id.slice(0, -5) in table.overrideTier) {
			return table.overrideTier[id.slice(0, -5)];
		}
		id = toID(pokemon.baseSpecies);
		if (id in table.overrideTier) {
			return table.overrideTier[id];
		}

		return pokemon.tier;
	}
	abstract getTable(): {[id: string]: any};
	abstract getDefaultResults(): SearchRow[];
	abstract getBaseResults(): SearchRow[];
	abstract filter(input: SearchRow, filters: string[][]): boolean;
	abstract sort(input: SearchRow[], sortCol: string, reverseSort?: boolean): SearchRow[];
}

class BattlePokemonSearch extends BattleTypedSearch<'pokemon'> {
	sortRow: SearchRow = ['sortpokemon', ''];
	getTable() {
		window.ensureCustomSpecies?.();
		return BattlePokedex;
	}
	getDefaultResults(): SearchRow[] {
		window.ensureCustomSpecies?.();
		let results: SearchRow[] = [];
		const seenSpecies = new Set<string>();
		for (let id in BattlePokedex) {
			switch (id) {
			case 'bulbasaur':
				results.push(['header', "Generation 1"]);
				break;
			case 'chikorita':
				results.push(['header', "Generation 2"]);
				break;
			case 'treecko':
				results.push(['header', "Generation 3"]);
				break;
			case 'turtwig':
				results.push(['header', "Generation 4"]);
				break;
			case 'victini':
				results.push(['header', "Generation 5"]);
				break;
			case 'chespin':
				results.push(['header', "Generation 6"]);
				break;
			case 'rowlet':
				results.push(['header', "Generation 7"]);
				break;
			case 'grookey':
				results.push(['header', "Generation 8"]);
				break;
			case 'sprigatito':
				results.push(['header', "Generation 9"]);
				break;
			}
			const species = this.dex.species.get(id);
			if ((isCustomSearchVisualForm(species) && species.tier === 'Illegal') || isHiddenTeamBuilderSpecies(id)) continue;
			const speciesid = toID(id);
			if (seenSpecies.has(speciesid)) continue;
			seenSpecies.add(speciesid);
			results.push(['pokemon', id as ID]);
		}
		return results;
	}
	getBaseResults(): SearchRow[] {
		const format = this.format;
		if (!format || this.unrestrictedCatalog) return this.getDefaultResults();
		const isVGCOrBS = format.startsWith('battlespot') || format.startsWith('bss') ||
			format.startsWith('battlestadium') || format.startsWith('vgc');
		const isHackmons = format.includes('hackmons') || format.endsWith('bh');
		let isDoublesOrBS = isVGCOrBS || this.formatType?.includes('doubles');
		const dex = this.dex;

		let table = BattleTeambuilderTable;
		if ((format.endsWith('cap') || format.endsWith('caplc')) && dex.gen < 9) {
			table = table['gen' + dex.gen];
		} else if (isVGCOrBS) {
			table = table['gen' + dex.gen + 'vgc'];
		} else if (dex.gen === 9 && isHackmons && !this.formatType) {
			table = table['bh'];
		} else if (
			table['gen' + dex.gen + 'doubles'] && dex.gen > 4 &&
			this.formatType !== 'letsgo' && this.formatType !== 'bdspdoubles' &&
			this.formatType !== 'ssdlc1doubles' && this.formatType !== 'predlcdoubles' &&
			this.formatType !== 'svdlc1doubles' && !this.formatType?.includes('natdex') &&
			(
				format.includes('doubles') || format.includes('triples') ||
				format === 'freeforall' || format.startsWith('ffa') ||
				format === 'partnersincrime'
			)
		) {
			table = table['gen' + dex.gen + 'doubles'];
			isDoublesOrBS = true;
		} else if (dex.gen < 9 && !this.formatType) {
			table = table['gen' + dex.gen];
		} else if (this.formatType?.startsWith('bdsp')) {
			table = table['gen8' + this.formatType];
		} else if (this.formatType === 'letsgo') {
			table = table['gen7letsgo'];
		} else if (this.formatType === 'natdex') {
			table = table['gen' + dex.gen + 'natdex'];
		} else if (this.formatType === 'metronome') {
			table = table['gen' + dex.gen + 'metronome'];
		} else if (this.formatType === 'nfe') {
			table = table['gen' + dex.gen + 'nfe'];
		} else if (this.formatType === 'lc') {
			table = table['gen' + dex.gen + 'lc'];
		} else if (this.formatType?.startsWith('ssdlc1')) {
			if (this.formatType.includes('doubles')) {
				table = table['gen8dlc1doubles'];
			} else {
				table = table['gen8dlc1'];
			}
		} else if (this.formatType?.startsWith('predlc')) {
			if (this.formatType.includes('doubles')) {
				table = table['gen9predlcdoubles'];
			} else if (this.formatType.includes('natdex')) {
				table = table['gen9predlcnatdex'];
			} else {
				table = table['gen9predlc'];
			}
		} else if (this.formatType?.startsWith('svdlc1')) {
			if (this.formatType.includes('doubles')) {
				table = table['gen9dlc1doubles'];
			} else if (this.formatType.includes('natdex')) {
				table = table['gen9dlc1natdex'];
			} else {
				table = table['gen9dlc1'];
			}
		} else if (this.formatType === 'stadium') {
			table = table['gen' + dex.gen + 'stadium' + (dex.gen > 1 ? dex.gen : '')];
		}

		if (!table.tierSet) {
			table.tierSet = table.tiers.map((r: any) => {
				if (typeof r === 'string') return ['pokemon', r];
				return [r[0], r[1]];
			});
			table.tiers = null;
		}
		let tierSet: SearchRow[] = table.tierSet;
		let slices: {[k: string]: number} = table.formatSlices;
		if (format === 'ubers' || format === 'uber' || format === 'ubersuu' || format === 'nationaldexdoubles') {
			tierSet = tierSet.slice(slices.Uber);
		} else if (isVGCOrBS || (isHackmons && dex.gen === 9 && !this.formatType)) {
			if (format.endsWith('series13') || isHackmons) {
				// Show Mythicals
			} else if (
				format === 'vgc2010' || format === 'vgc2016' || format.startsWith('vgc2019') ||
				format === 'vgc2022' || format.endsWith('series10') || format.endsWith('series11')
			) {
				tierSet = tierSet.slice(slices["Restricted Legendary"]);
			} else {
				tierSet = tierSet.slice(slices.Regular);
			}
		} else if (format === 'ou') tierSet = tierSet.slice(slices.OU);
		else if (format === 'uu' || (format === 'ru' && dex.gen === 3)) tierSet = tierSet.slice(slices.UU);
		else if (format === 'ru') tierSet = tierSet.slice(slices.RU || slices.UU);
		else if (format === 'nu') tierSet = tierSet.slice(slices.NU || slices.RU || slices.UU);
		else if (format === 'pu') tierSet = tierSet.slice(slices.PU || slices.NU);
		else if (format === 'zu') tierSet = tierSet.slice(slices.ZU || slices.PU || slices.NU);
		else if (format === 'lc' || format === 'lcuu' || format.startsWith('lc') || (format !== 'caplc' && format.endsWith('lc'))) tierSet = tierSet.slice(slices.LC);
		else if (format === 'cap' || format.endsWith('cap')) {
			tierSet = tierSet.slice(0, slices.AG || slices.Uber).concat(tierSet.slice(slices.OU));
		} else if (format === 'caplc') {
			tierSet = tierSet.slice(slices['CAP LC'], slices.AG || slices.Uber).concat(tierSet.slice(slices.LC));
		} else if (format === 'anythinggoes' || format.endsWith('ag') || format.startsWith('ag')) {
			tierSet = tierSet.slice(slices.AG);
		} else if (isHackmons && (dex.gen < 9 || this.formatType === 'natdex')) {
			tierSet = tierSet.slice(slices.AG || slices.Uber);
		} else if (format === 'monotype' || format.startsWith('monothreat')) tierSet = tierSet.slice(slices.Uber);
		else if (format === 'doublesubers') tierSet = tierSet.slice(slices.DUber);
		else if (format === 'doublesou' && dex.gen > 4) tierSet = tierSet.slice(slices.DOU);
		else if (format === 'doublesuu') tierSet = tierSet.slice(slices.DUU);
		else if (format === 'doublesnu') tierSet = tierSet.slice(slices.DNU || slices.DUU);
		else if (this.formatType?.startsWith('bdsp') || this.formatType === 'letsgo' || this.formatType === 'stadium') {
			tierSet = tierSet.slice(slices.Uber);
		} else if (!isDoublesOrBS) {
			tierSet = [
				...tierSet.slice(slices.OU, slices.UU),
				...tierSet.slice(slices.AG, slices.Uber),
				...tierSet.slice(slices.Uber, slices.OU),
				...tierSet.slice(slices.UU),
			];
		} else {
			tierSet = [
				...tierSet.slice(slices.DOU, slices.DUU),
				...tierSet.slice(slices.DUber, slices.DOU),
				...tierSet.slice(slices.DUU),
			];
		}

		if (format === 'ubersuu' && table.ubersUUBans) {
			tierSet = tierSet.filter(([type, id]) => {
				if (id in table.ubersUUBans) return false;
				return true;
			});
		}
		if (format === 'nationaldexdoubles' && table.ndDoublesBans) {
			tierSet = tierSet.filter(([type, id]) => {
				if (id in table.ndDoublesBans) return false;
				return true;
			});
		}
		if (dex.gen >= 5) {
			if ((format === 'monotype' || format.startsWith('monothreat')) && table.monotypeBans) {
				tierSet = tierSet.filter(([type, id]) => {
					if (id in table.monotypeBans) return false;
					return true;
				});
			}
		}

		// Filter out Gmax Pokemon from standard tier selection
		if (!this.isFieldFormat && !/^(battlestadium|vgc|doublesubers)/g.test(format)) {
			tierSet = tierSet.filter(([type, id]) => {
				if (type === 'header' && id === 'DUber by technicality') return false;
				if (type === 'pokemon') return !id.endsWith('gmax');
				return true;
			});
		}

		// CAP species are not part of this server's public roster and should not
		// appear as legal or illegal choices in any format.
		tierSet = tierSet.filter(([type, id]) => {
			if (type === 'pokemon') return !isCAPSpecies(id);
			if (type === 'header') return !id.startsWith('CAP');
			return true;
		});

		// New standalone profiles have no upstream tier-table entry or legal base
		// slot to inherit. Put them under an explicit Custom heading so they cannot
		// inherit the preceding tier label (formerly CAP for Clawitzer-Mega).
		if (this.isFieldFormat || this.unrestrictedCatalog || this.formatType === 'natdex') {
			window.ensureCustomSpecies?.();
			tierSet = [...tierSet];
			const listedSpecies = new Set(tierSet.filter(row => row[0] === 'pokemon').map(row => row[1]));
			const customSpecies: SearchRow[] = [];
			for (const id in BattlePokedex) {
				const species = dex.species.get(id);
				if (isCustomSearchVisualForm(species) && species.tier !== 'Illegal' &&
					!listedSpecies.has(id as ID) && !isHiddenTeamBuilderSpecies(id)) {
					customSpecies.push(['pokemon', id as ID]);
				}
			}
			if (customSpecies.length) tierSet.push(['header', 'Custom'], ...customSpecies);
		}
		const seenSpecies = new Set<string>();
		tierSet = tierSet.filter(([type, id]) => {
			if (type !== 'pokemon') return true;
			const speciesid = toID(id);
			if (isHiddenTeamBuilderSpecies(speciesid)) return false;
			if (seenSpecies.has(speciesid)) return false;
			seenSpecies.add(speciesid);
			return true;
		});

		return tierSet;
	}
	filter(row: SearchRow, filters: string[][]) {
		if (!filters) return true;
		if (row[0] !== 'pokemon') return true;
		const species = this.dex.species.get(row[1]);
		for (const [filterType, value] of filters) {
			switch (filterType) {
			case 'type':
				if (species.types[0] !== value && species.types[1] !== value) return false;
				break;
			case 'egggroup':
				if (species.eggGroups[0] !== value && species.eggGroups[1] !== value) return false;
				break;
			case 'tier':
				if (this.getTier(species) !== value) return false;
				break;
			case 'ability':
				if (!Dex.hasAbilityEffect(species, value)) return false;
				break;
			case 'move':
				if (!this.canLearn(species.id, value as ID)) return false;
			}
		}
		return true;
	}
	sort(results: SearchRow[], sortCol: string, reverseSort?: boolean) {
		const sortOrder = reverseSort ? -1 : 1;
		if (['hp', 'atk', 'def', 'spa', 'spd', 'spe'].includes(sortCol)) {
			return results.sort(([rowType1, id1], [rowType2, id2]) => {
				const stat1 = this.dex.species.get(id1).baseStats[sortCol as StatName];
				const stat2 = this.dex.species.get(id2).baseStats[sortCol as StatName];
				return (stat2 - stat1) * sortOrder;
			});
		} else if (sortCol === 'bst') {
			return results.sort(([rowType1, id1], [rowType2, id2]) => {
				const base1 = this.dex.species.get(id1).baseStats;
				const base2 = this.dex.species.get(id2).baseStats;
				let bst1 = base1.hp + base1.atk + base1.def + base1.spa + base1.spd + base1.spe;
				let bst2 = base2.hp + base2.atk + base2.def + base2.spa + base2.spd + base2.spe;
				if (this.dex.gen === 1) {
					bst1 -= base1.spd;
					bst2 -= base2.spd;
				}
				return (bst2 - bst1) * sortOrder;
			});
		} else if (sortCol === 'name') {
			return results.sort(([rowType1, id1], [rowType2, id2]) => {
				const name1 = id1;
				const name2 = id2;
				return (name1 < name2 ? -1 : name1 > name2 ? 1 : 0) * sortOrder;
			});
		}
		throw new Error("invalid sortcol");
	}
}

class BattleAbilitySearch extends BattleTypedSearch<'ability'> {
	getTable() {
		window.ensureCustomDataPatches?.();
		return BattleAbilities;
	}
	getDefaultResults(): SearchRow[] {
		window.ensureCustomDataPatches?.();
		const results: SearchRow[] = [];
		for (let id in BattleAbilities) {
			results.push(['ability', id as ID]);
		}
		return results;
	}
	getBaseResults() {
		if (!this.species) return this.getDefaultResults();
		const format = this.format;
		const isHackmons = (format.includes('hackmons') || format.endsWith('bh'));
		const isAAA = (format === 'almostanyability' || format.includes('aaa'));
		const dex = this.dex;
		let species = dex.species.get(this.species);
		let abilitySet: SearchRow[] = [['header', "Abilities"]];
        const regionalPair = Dex.getRegionalAbilityPair(species.name, dex);
        if (regionalPair) species = dex.species.get(regionalPair.base);


		if (species.isMega) {
			const megaAbility = species.abilities['0'];
			abilitySet.push(['header', "Mega Ability"]);
			abilitySet.push(['ability', dex.abilities.get(megaAbility).id]);
			abilitySet.unshift(['html', `Will be <strong>${megaAbility}</strong> after Mega Evolving.`]);
			species = dex.species.get(species.baseSpecies);
		}
		abilitySet.push(['ability', dex.abilities.get(species.abilities['0']).id]);
		if (species.abilities['1']) {
			abilitySet.push(['ability', dex.abilities.get(species.abilities['1']).id]);
		}
		if (species.abilities['H']) {
			abilitySet.push(['header', "Hidden Ability"]);
			abilitySet.push(['ability', dex.abilities.get(species.abilities['H']).id]);
		}
		const eventAbilitySlots = ['S', 'E', 'F', 'G'] as const;
		const eventAbilities = eventAbilitySlots
			.map(slot => species.abilities[slot])
			.filter((ability): ability is string => !!ability && !(species.id === 'veluza' && toID(ability) === 'unburden'));
		if (species.id === 'veluza' && species.abilities['E'] === 'Unburden') {
			abilitySet.push(['header', "Additional Ability"]);
			abilitySet.push(['ability', toID('Unburden')]);
		}
		if (eventAbilities.length) {
			abilitySet.push(['header', "Special Event Abilities"]);
			for (const ability of eventAbilities) {
				abilitySet.push(['ability', dex.abilities.get(ability).id]);
			}
		}
		if (isAAA || format.includes('metronomebattle') || isHackmons) {
			let abilities: ID[] = [];
			for (let i in this.getTable()) {
				const ability = dex.abilities.get(i);
				if (ability.isNonstandard) continue;
				if (ability.gen > dex.gen) continue;
				abilities.push(ability.id);
			}

			let goodAbilities: SearchRow[] = [['header', "Abilities"]];
			let poorAbilities: SearchRow[] = [['header', "Situational Abilities"]];
			let badAbilities: SearchRow[] = [['header', "Unviable Abilities"]];
			for (const ability of abilities.sort().map(abil => dex.abilities.get(abil))) {
				let rating = ability.rating;
				if (ability.id === 'normalize') rating = 3;
				if (rating >= 3) {
					goodAbilities.push(['ability', ability.id]);
				} else if (rating >= 2) {
					poorAbilities.push(['ability', ability.id]);
				} else {
					badAbilities.push(['ability', ability.id]);
				}
			}
			abilitySet = [...goodAbilities, ...poorAbilities, ...badAbilities];
			if (species.isMega) {
				if (isAAA) {
					abilitySet.unshift(['html', `Will be <strong>${species.abilities['0']}</strong> after Mega Evolving.`]);
				}
				// species is unused after this, so no need to replace
			}
		}
		return abilitySet;
	}
	filter(row: SearchRow, filters: string[][]) {
		if (!filters) return true;
		if (row[0] !== 'ability') return true;
		const ability = this.dex.abilities.get(row[1]);
		for (const [filterType, value] of filters) {
			switch (filterType) {
			case 'pokemon':
				if (!Dex.hasAbilityEffect(this.dex.species.get(value), ability.name)) return false;
				break;
			}
		}
		return true;
	}
	sort(results: SearchRow[], sortCol: string | null, reverseSort?: boolean): SearchRow[] {
		throw new Error("invalid sortcol");
	}
}

class BattleItemSearch extends BattleTypedSearch<'item'> {
	getTable() {
		return BattleItems;
	}
	getDefaultResults(): SearchRow[] {
		Dex.items.get('amplifieldrock');
		let table = BattleTeambuilderTable;
		if (this.formatType?.startsWith('bdsp')) {
			table = table['gen8bdsp'];
		} else if (this.formatType === 'natdex') {
			table = table['gen' + this.dex.gen + 'natdex'];
		} else if (this.formatType === 'metronome') {
			table = table['gen' + this.dex.gen + 'metronome'];
		} else if (this.dex.gen < 9) {
			table = table['gen' + this.dex.gen];
		}
		if (!table.itemSet) {
			table.itemSet = table.items.map((r: any) => {
				if (typeof r === 'string') {
					return ['item', r];
				}
				return [r[0], r[1]];
			});
			table.items = null;
		}
		return table.itemSet;
	}
	getBaseResults(): SearchRow[] {
		if (!this.species) return this.getDefaultResults();
		const speciesName = this.dex.species.get(this.species).name;
		const results = this.getDefaultResults();
		const speciesSpecific: SearchRow[] = [];
		for (const row of results) {
			if (row[0] !== 'item') continue;
			if (this.dex.items.get(row[1]).itemUser?.includes(speciesName)) {
				speciesSpecific.push(row);
			}
		}
		if (speciesSpecific.length) {
			return [
				['header', "Specific to " + speciesName],
				...speciesSpecific,
				...results,
			];
		}
		return results;
	}
	filter(row: SearchRow, filters: string[][]) {
		if (!filters) return true;
		if (row[0] !== 'ability') return true;
		const ability = this.dex.abilities.get(row[1]);
		for (const [filterType, value] of filters) {
			switch (filterType) {
			case 'pokemon':
				if (!Dex.hasAbilityEffect(this.dex.species.get(value), ability.name)) return false;
				break;
			}
		}
		return true;
	}
	sort(results: SearchRow[], sortCol: string | null, reverseSort?: boolean): SearchRow[] {
		throw new Error("invalid sortcol");
	}
}

class BattleMoveSearch extends BattleTypedSearch<'move'> {
	/** Show the source beside its move instead of repeating the entire list in a paragraph. */
	sortRow: SearchRow = ['sortmove', ''];
	getTable() {
		window.ensureCustomDataPatches?.();
		return BattleMovedex;
	}
	getDefaultResults(): SearchRow[] {
		window.ensureCustomDataPatches?.();
		let results: SearchRow[] = [];
		results.push(['header', "Moves"]);
		for (let id in BattleMovedex) {
			switch (id) {
			case 'paleowave':
				results.push(['header', "CAP moves"]);
				break;
			case 'magikarpsrevenge':
				continue;
			}
			results.push(['move', id as ID]);
		}
		return results;
	}
	private moveIsNotUseless(id: ID, species: Species, moves: string[], set: PokemonSet | null) {
		const dex = this.dex;

		let abilityid: ID = set ? toID(set.ability) : '' as ID;
		if ((species.id === 'alakazamrejuv' || (species.id === 'alakazam' && abilityid === 'aeviandiscipline')) && AEVIAN_DISCIPLINE_MOVES.includes(id)) return true;
		if ((species.id === 'sigilyphrejuv' || (species.id === 'sigilyph' && abilityid === 'aeviangrief')) &&
			AEVIAN_GRIEF_MOVE_IDS.includes(id)) return true;
		const itemid: ID = set ? toID(set.item) : '' as ID;
		if (
			['eeveestarter', 'eeveestarteralt', 'divineon'].includes(species.id) &&
			abilityid === 'sinisterblaze' && SINISTER_BLAZE_EEVEE_MOVES.includes(id)
		) {
			return true;
		}
		if (
			['eeveestarter', 'eeveestarteralt', 'divineon'].includes(species.id) &&
			abilityid === 'ascendance' && ASCENDANCE_EEVEE_MOVES.includes(id)
		) {
			return true;
		}
		if (species.id === 'umbreon' && abilityid === 'ascendance' && id === 'radiantassault') {
			return true;
		}

		if (dex.gen === 1) {
			// Usually not useless for Gen 1
			if ([
				'acidarmor', 'amnesia', 'barrier', 'bind', 'blizzard', 'clamp', 'confuseray', 'counter', 'firespin', 'growth', 'headbutt', 'hyperbeam', 'mirrormove', 'pinmissile', 'razorleaf', 'sing', 'slash', 'sludge', 'twineedle', 'wrap',
			].includes(id)) {
				return true;
			}

			// Usually useless for Gen 1
			if ([
				'disable', 'haze', 'leechseed', 'quickattack', 'roar', 'thunder', 'toxic', 'triattack', 'waterfall', 'whirlwind',
			].includes(id)) {
				return false;
			}

			// Not useless only when certain moves aren't present
			switch (id) {
			case 'bubblebeam': return (!moves.includes('surf') && !moves.includes('blizzard'));
			case 'doubleedge': return !moves.includes('bodyslam');
			case 'doublekick': return !moves.includes('submission');
			case 'firepunch': return !moves.includes('fireblast');
			case 'megadrain': return !moves.includes('razorleaf') && !moves.includes('surf');
			case 'megakick': return !moves.includes('hyperbeam');
			case 'reflect': return !moves.includes('barrier') && !moves.includes('acidarmor');
			case 'stomp': return !moves.includes('headbutt');
			case 'submission': return !moves.includes('highjumpkick');
			case 'thunderpunch': return !moves.includes('thunderbolt');
			case 'triattack': return !moves.includes('bodyslam');
			}
			// Useful and Useless moves for Stadium OU, which changes many game mechanics.
			if (this.formatType === 'stadium') {
				if (['doubleedge', 'focusenergy', 'haze'].includes(id)) return true;
				if (['hyperbeam', 'sing', 'hypnosis'].includes(id)) return false;
				switch (id) {
				case 'fly': return !moves.includes('drillpeck');
				case 'dig': return !moves.includes('earthquake');
				}
			}
		}

		if (this.formatType === 'letsgo') {
			if (['megadrain', 'teleport'].includes(id)) return true;
		}

		if (this.formatType === 'metronome') {
			if (id === 'metronome') return true;
		}

		if (itemid === 'pidgeotite') abilityid = 'noguard' as ID;
		if (itemid === 'blastoisinite') abilityid = 'megalauncher' as ID;
		if (itemid === 'aerodactylite') abilityid = 'toughclaws' as ID;
		if (itemid === 'glalitite') abilityid = 'refrigerate' as ID;

		switch (id) {
		case 'fakeout': case 'flamecharge': case 'nuzzle': case 'poweruppunch': case 'trailblaze':
			return abilityid !== 'sheerforce';
		case 'solarbeam': case 'solarblade':
			return ['desolateland', 'drought', 'chlorophyll', 'orichalcumpulse'].includes(abilityid) || itemid === 'powerherb';
		case 'dynamicpunch': case 'grasswhistle': case 'inferno': case 'sing': case 'zapcannon':
			return abilityid === 'noguard';
		case 'heatcrash': case 'heavyslam':
			return species.weightkg >= (species.evos ? 75 : 130);
		case 'aerialace':
			return ['technician', 'toughclaws'].includes(abilityid) && !moves.includes('bravebird');
		case 'ancientpower':
			return ['serenegrace', 'technician'].includes(abilityid) || !moves.includes('powergem');
		case 'aquajet':
			return !moves.includes('jetpunch');
		case 'aurawheel':
			return species.baseSpecies === 'Morpeko';
		case 'axekick':
			return !moves.includes('highjumpkick');
		case 'bellydrum':
			return moves.includes('aquajet') || moves.includes('jetpunch') || moves.includes('extremespeed') ||
				['iceface', 'unburden'].includes(abilityid);
		case 'bulletseed':
			return ['skilllink', 'technician'].includes(abilityid);
		case 'chillingwater':
			return !moves.includes('scald');
		case 'counter':
			return species.baseStats.hp >= 65;
		case 'dazzlinggleam':
			return !moves.includes('alluringvoice') || this.formatType?.includes('doubles');
		case 'darkvoid':
			return dex.gen < 7;
		case 'dualwingbeat':
			return abilityid === 'technician' || !moves.includes('drillpeck');
		case 'electroshot':
			return true;
		case 'feint':
			return abilityid === 'refrigerate';
		case 'grassyglide':
			return abilityid === 'grassysurge';
		case 'gyroball':
			return species.baseStats.spe <= 60;
		case 'headbutt':
			return abilityid === 'serenegrace';
		case 'hex':
			return !moves.includes('infernalparade');
		case 'hiddenpowerelectric':
			return (dex.gen < 4 && !moves.includes('thunderpunch')) && !moves.includes('thunderbolt');
		case 'hiddenpowerfighting':
			return (dex.gen < 4 && !moves.includes('brickbreak')) && !moves.includes('aurasphere') && !moves.includes('focusblast');
		case 'hiddenpowerfire':
			return (dex.gen < 4 && !moves.includes('firepunch')) && !moves.includes('flamethrower') &&
				!moves.includes('mysticalfire') && !moves.includes('burningjealousy');
		case 'hiddenpowergrass':
			return !moves.includes('energyball') && !moves.includes('grassknot') && !moves.includes('gigadrain');
		case 'hiddenpowerice':
			return !moves.includes('icebeam') && (dex.gen < 4 && !moves.includes('icepunch')) ||
				(dex.gen > 5 && !moves.includes('aurorabeam') && !moves.includes('glaciate'));
		case 'hiddenpowerflying':
			return dex.gen < 4 && !moves.includes('drillpeck');
		case 'hiddenpowerbug':
			return dex.gen < 4 && !moves.includes('megahorn');
		case 'hiddenpowerpsychic':
			return species.baseSpecies === 'Unown';
		case 'hyperspacefury':
			return species.id === 'hoopaunbound';
		case 'hypnosis':
			return (dex.gen < 4 && !moves.includes('sleeppowder')) || (dex.gen > 6 && abilityid === 'baddreams');
		case 'icepunch':
			return !moves.includes('icespinner') || ['sheerforce', 'ironfist'].includes(abilityid) || itemid === 'punchingglove';
		case 'iciclecrash':
			return !moves.includes('mountaingale');
		case 'icywind':
			// Keldeo needs Hidden Power for Electric/Ghost
			return species.baseSpecies === 'Keldeo' || this.formatType === 'doubles';
		case 'infestation':
			return moves.includes('stickyweb');
		case 'irondefense':
			return !moves.includes('acidarmor');
		case 'irontail':
			return dex.gen > 5 && !moves.includes('ironhead') && !moves.includes('gunkshot') && !moves.includes('poisonjab');
		case 'jumpkick':
			return !moves.includes('highjumpkick') && !moves.includes('axekick');
		case 'lastresort':
			return set && set.moves.length < 3;
		case 'leechlife':
			return dex.gen > 6;
		case 'meteorbeam':
			return true;
		case 'mysticalfire':
			return dex.gen > 6 && !moves.includes('flamethrower');
		case 'naturepower':
			return dex.gen === 5;
		case 'nightslash':
			return !moves.includes('crunch') && !(moves.includes('knockoff') && dex.gen >= 6);
		case 'outrage':
			return !moves.includes('glaiverush');
		case 'petaldance':
			return abilityid === 'owntempo';
		case 'phantomforce':
			return (!moves.includes('poltergeist') && !moves.includes('shadowclaw')) || this.formatType === 'doubles';
		case 'poisonfang':
			return species.types.includes('Poison') && !moves.includes('gunkshot') && !moves.includes('poisonjab');
		case 'relicsong':
			return species.id === 'meloetta';
		case 'refresh':
			return !moves.includes('aromatherapy') && !moves.includes('healbell');
		case 'risingvoltage':
			return abilityid === 'electricsurge' || abilityid === 'hadronengine';
		case 'rocktomb':
			return abilityid === 'technician';
		case 'selfdestruct':
			return dex.gen < 5 && !moves.includes('explosion');
		case 'shadowpunch':
			return abilityid === 'ironfist' && !moves.includes('ragefist');
		case 'shelter':
			return !moves.includes('acidarmor') && !moves.includes('irondefense');
		case 'smackdown':
			return species.types.includes('Ground');
		case 'smartstrike':
			return species.types.includes('Steel') && !moves.includes('ironhead');
		case 'soak':
			return abilityid === 'unaware';
		case 'steelwing':
			return !moves.includes('ironhead');
		case 'stompingtantrum':
			return (!moves.includes('earthquake') && !moves.includes('drillrun')) || this.formatType === 'doubles';
		case 'stunspore':
			return !moves.includes('thunderwave');
		case 'technoblast':
			return dex.gen > 5 && itemid.endsWith('drive') || itemid === 'dousedrive';
		case 'teleport':
			return dex.gen > 7;
		case 'temperflare':
			return (!moves.includes('flareblitz') && !moves.includes('pyroball') && !moves.includes('sacredfire') &&
				!moves.includes('bitterblade') && !moves.includes('firepunch')) || this.formatType === 'doubles';
		case 'terrainpulse': case 'waterpulse':
			return ['megalauncher', 'technician'].includes(abilityid) && !moves.includes('originpulse');
		case 'thief':
			return dex.gen === 2;
		case 'toxicspikes':
			return abilityid !== 'toxicdebris';
		case 'trickroom':
			return species.baseStats.spe <= 100;
		case 'wildcharge':
			return !moves.includes('supercellslam');
		}

		if (this.formatType === 'doubles' && BattleMoveSearch.GOOD_DOUBLES_MOVES.includes(id)) {
			return true;
		}

		const move = dex.moves.get(id);
		if (!move.exists) return true;
		if ((move.status === 'slp' || id === 'yawn') && dex.gen === 9 && !this.formatType) {
			return false;
		}
		if (move.category === 'Status') {
			return BattleMoveSearch.GOOD_STATUS_MOVES.includes(id);
		}
		if (move.basePower < 75) {
			return BattleMoveSearch.GOOD_WEAK_MOVES.includes(id);
		}
		if (id === 'skydrop') return true;
		// strong moves
		if (move.flags['charge']) {
			return itemid === 'powerherb';
		}
		if (move.flags['recharge']) {
			return false;
		}
		if (move.flags['slicing'] && abilityid === 'sharpness') {
			return true;
		}
		return !BattleMoveSearch.BAD_STRONG_MOVES.includes(id);
	}
	static readonly GOOD_STATUS_MOVES = [
		'acidarmor', 'agility', 'aromatherapy', 'auroraveil', 'autotomize', 'banefulbunker', 'batonpass', 'bellydrum', 'bulkup', 'burningbulwark', 'calmmind', 'chillyreception', 'clangoroussoul', 'coil', 'cottonguard', 'courtchange', 'curse', 'defog', 'destinybond', 'detect', 'disable', 'dragondance', 'encore', 'extremeevoboost', 'filletaway', 'geomancy', 'glare', 'haze', 'healbell', 'healingwish', 'healorder', 'heartswap', 'honeclaws', 'kingsshield', 'leechseed', 'lightscreen', 'lovelykiss', 'lunardance', 'magiccoat', 'maxguard', 'memento', 'milkdrink', 'moonlight', 'morningsun', 'nastyplot', 'naturesmadness', 'noretreat', 'obstruct', 'painsplit', 'partingshot', 'perishsong', 'protect', 'quiverdance', 'recover', 'reflect', 'reflecttype', 'rest', 'revivalblessing', 'roar', 'rockpolish', 'roost', 'shedtail', 'shellsmash', 'shiftgear', 'shoreup', 'silktrap', 'slackoff', 'sleeppowder', 'sleeptalk', 'softboiled', 'spikes', 'spikyshield', 'spore', 'stealthrock', 'stickyweb', 'strengthsap', 'substitute', 'switcheroo', 'swordsdance', 'synthesis', 'tailglow', 'tailwind', 'taunt', 'thunderwave', 'tidyup', 'toxic', 'transform', 'trick', 'victorydance', 'whirlwind', 'willowisp', 'wish', 'yawn', 'coldsnap'
	] as ID[] as readonly ID[];
	static readonly GOOD_WEAK_MOVES = [
		'accelerock', 'acrobatics', 'aquacutter', 'avalanche', 'barbbarrage', 'bonemerang', 'bouncybubble', 'bulletpunch', 'buzzybuzz', 'ceaselessedge', 'circlethrow', 'clearsmog', 'doubleironbash', 'dragondarts', 'dragontail', 'drainingkiss', 'endeavor', 'facade', 'firefang', 'flipturn', 'flowertrick', 'freezedry', 'frustration', 'geargrind', 'grassknot', 'gyroball', 'icefang', 'iceshard', 'iciclespear', 'infernalparade', 'knockoff', 'lastrespects', 'lowkick', 'machpunch', 'mortalspin', 'mysticalpower', 'naturesmadness', 'nightshade', 'nuzzle', 'pikapapow', 'populationbomb', 'psychocut', 'psyshieldbash', 'pursuit', 'quickattack', 'ragefist', 'rapidspin', 'return', 'rockblast', 'ruination', 'saltcure', 'scorchingsands', 'seismictoss', 'shadowclaw', 'shadowsneak', 'sizzlyslide', 'stoneaxe', 'storedpower', 'stormthrow', 'suckerpunch', 'superfang', 'surgingstrikes', 'tachyoncutter', 'tailslap', 'thunderclap', 'tripleaxel', 'tripledive', 'twinbeam', 'uturn', 'veeveevolley', 'voltswitch', 'watershuriken', 'weatherball',
	] as ID[] as readonly ID[];
	static readonly BAD_STRONG_MOVES = [
		'belch', 'burnup', 'crushclaw', 'dragonrush', 'dreameater', 'eggbomb', 'firepledge', 'flyingpress', 'grasspledge', 'hyperbeam', 'hyperfang', 'hyperspacehole', 'jawlock', 'landswrath', 'megakick', 'megapunch', 'mistyexplosion', 'muddywater', 'nightdaze', 'pollenpuff', 'rockclimb', 'selfdestruct', 'shelltrap', 'skyuppercut', 'slam', 'strength', 'submission', 'synchronoise', 'takedown', 'thrash', 'uproar', 'waterpledge',
	] as ID[] as readonly ID[];
	static readonly GOOD_DOUBLES_MOVES = [
		'allyswitch', 'bulldoze', 'coaching', 'electroweb', 'faketears', 'fling', 'followme', 'healpulse', 'helpinghand', 'junglehealing', 'lifedew', 'lunarblessing', 'muddywater', 'pollenpuff', 'psychup', 'ragepowder', 'safeguard', 'skillswap', 'snipeshot', 'wideguard',
	] as ID[] as readonly ID[];
	getBaseResults() {
		if (!this.species) return this.getDefaultResults();
		const dex = this.dex;
		let species = dex.species.get(this.species);
		const format = this.format;
		const isHackmons = (format.includes('hackmons') || format.endsWith('bh'));
		const isSTABmons = (format.includes('stabmons') || format === 'staaabmons');
		const isTradebacks = format.includes('tradebacks');
		const regionBornLegality = !this.unrestrictedCatalog && dex.gen >= 6 &&
			(/^battle(spot|stadium|festival)/.test(format) || format.startsWith('bss') ||
				format.startsWith('vgc') || (dex.gen === 9 && this.formatType !== 'natdex'));

		let learnsetid = this.firstLearnsetid(species.id);
		let moves: string[] = [];
		let sketchMoves: string[] = [];
		let sketch = false;
		let gen = '' + dex.gen;
		let lsetTable = BattleTeambuilderTable;
		if (this.formatType?.startsWith('bdsp')) lsetTable = lsetTable['gen8bdsp'];
		if (this.formatType === 'letsgo') lsetTable = lsetTable['gen7letsgo'];
		if (this.formatType?.startsWith('ssdlc1')) lsetTable = lsetTable['gen8dlc1'];
		if (this.formatType?.startsWith('predlc')) lsetTable = lsetTable['gen9predlc'];
		if (this.formatType?.startsWith('svdlc1')) lsetTable = lsetTable['gen9dlc1'];
		while (learnsetid) {
			let learnset = lsetTable.learnsets[learnsetid];
			if (learnset) {
				for (let moveid in learnset) {
					if (moveid.startsWith('hiddenpower')) continue;
					let learnsetEntry = learnset[moveid];
					const move = dex.moves.get(moveid);
					const minGenCode: {[gen: number]: string} = {6: 'p', 7: 'q', 8: 'g', 9: 'a'};
					if (regionBornLegality && !learnsetEntry.includes(minGenCode[dex.gen])) {
						continue;
					}
					if (
						!learnsetEntry.includes(gen) &&
						(!isTradebacks ? true : !(move.gen <= dex.gen && learnsetEntry.includes('' + (dex.gen + 1))))
					) {
						continue;
					}
					if (!this.unrestrictedCatalog && this.formatType !== 'natdex' && move.isNonstandard === "Past") {
						continue;
					}
					if (
						this.formatType?.startsWith('dlc1') &&
						BattleTeambuilderTable['gen8dlc1']?.nonstandardMoves.includes(moveid)
					) {
						continue;
					}
					if (
						this.formatType?.includes('predlc') && this.formatType !== 'predlcnatdex' &&
						BattleTeambuilderTable['gen9predlc']?.nonstandardMoves.includes(moveid)
					) {
						continue;
					}
					if (
						this.formatType?.includes('svdlc1') && this.formatType !== 'svdlc1natdex' &&
						BattleTeambuilderTable['gen9dlc1']?.nonstandardMoves.includes(moveid)
					) {
						continue;
					}
					if (moves.includes(moveid)) continue;
					moves.push(moveid);
					if (moveid === 'sketch') sketch = true;
					if (moveid === 'hiddenpower') {
						moves.push(
							'hiddenpowerbug', 'hiddenpowerdark', 'hiddenpowerdragon', 'hiddenpowerelectric', 'hiddenpowerfighting', 'hiddenpowerfire', 'hiddenpowerflying', 'hiddenpowerghost', 'hiddenpowergrass', 'hiddenpowerground', 'hiddenpowerice', 'hiddenpowerpoison', 'hiddenpowerpsychic', 'hiddenpowerrock', 'hiddenpowersteel', 'hiddenpowerwater'
						);
					}
				}
			}
			learnsetid = this.nextLearnsetid(learnsetid, species.id);
		}
		if (sketch || isHackmons) {
			if (isHackmons) moves = [];
			for (let id in BattleMovedex) {
				if (id.startsWith('hiddenpower')) continue;
				if (!format.startsWith('cap') && (id === 'paleowave' || id === 'shadowstrike')) continue;
				const move = dex.moves.get(id);
				if (move.gen > dex.gen) continue;
				if (sketch) {
					if (move.noSketch || move.isMax || move.isZ) continue;
					if (move.isNonstandard && move.isNonstandard !== 'Past') continue;
					if (move.isNonstandard === 'Past' && this.formatType !== 'natdex') continue;
					sketchMoves.push(move.id);
				} else {
					if (!(dex.gen < 8 || this.formatType === 'natdex') && move.isZ) continue;
					if (typeof move.isMax === 'string') continue;
					if (move.isMax && dex.gen > 8) continue;
					if (move.isNonstandard === 'Past' && this.formatType !== 'natdex') continue;
					if (move.isNonstandard === 'LGPE' && this.formatType !== 'letsgo') continue;
					moves.push(move.id);
				}
			}
		}
		if (dex.gen >= 9 && !isHackmons) {
			const exclusions = Dex.getGen9MoveRemovals(species.id);
			moves = moves.filter(id => !exclusions.includes(id));
		}
		if (this.formatType === 'metronome') moves = ['metronome'];
		if (isSTABmons) {
			for (let id in this.getTable()) {
				if (id.startsWith('hiddenpower')) continue;
				const move = dex.moves.get(id);
				if (moves.includes(move.id)) continue;
				if (move.gen > dex.gen) continue;
				if (move.isZ || move.isMax || (move.isNonstandard && move.isNonstandard !== 'Unobtainable')) continue;

				const speciesTypes: string[] = [];
				const moveTypes: string[] = [];
				for (let i = dex.gen; i >= species.gen && i >= move.gen; i--) {
					const genDex = Dex.forGen(i);
					moveTypes.push(genDex.moves.get(move.name).type);

					const pokemon = genDex.species.get(species.name);
					let baseSpecies = genDex.species.get(pokemon.changesFrom || pokemon.name);
					if (!pokemon.battleOnly) speciesTypes.push(...pokemon.types);
					let prevo = pokemon.prevo;
					while (prevo) {
						const prevoSpecies = genDex.species.get(prevo);
						speciesTypes.push(...prevoSpecies.types);
						prevo = prevoSpecies.prevo;
					}
					if (pokemon.battleOnly && typeof pokemon.battleOnly === 'string') {
						species = dex.species.get(pokemon.battleOnly);
					}
					const excludedForme = (s: Species) => [
						'Alola', 'Alola-Totem', 'Galar', 'Galar-Zen', 'Hisui', 'Paldea', 'Paldea-Combat', 'Paldea-Blaze', 'Paldea-Aqua',
					].includes(s.forme);
					if (baseSpecies.otherFormes && !['Wormadam', 'Urshifu'].includes(baseSpecies.baseSpecies)) {
						if (!excludedForme(species)) speciesTypes.push(...baseSpecies.types);
						for (const formeName of baseSpecies.otherFormes) {
							const forme = dex.species.get(formeName);
							if (!forme.battleOnly && !excludedForme(forme)) speciesTypes.push(...forme.types);
						}
					}
				}
				let valid = false;
				for (let type of moveTypes) {
					if (speciesTypes.includes(type)) {
						valid = true;
						break;
					}
				}
				if (valid) moves.push(id);
			}
		}

		const eeveeStarterMoveOrder = [
			// Eevee signature and Let's Go moves stay together at the top.
			'spookyspell', 'glitchygraphics', 'searingvoid', 'veeveevolley',
			'glitzyglow', 'baddybad', 'freezyfrost', 'sappyseed', 'sizzleslide',
			'buzzybuzz', 'bouncybubble', 'sparklyswirl',
			'punchypummel', 'twirlytwister', 'rockyrampage', 'dustydrift', 'steelystrike',
			'stabbyswarm', 'ickyinjection', 'scalyscorn',
		];
		const isEeveeStarter = ['eeveestarter', 'eeveestarteralt', 'divineon'].includes(species.id);
		const isUmbreonAscendance = species.id === 'umbreon' && toID(this.set?.ability) === 'ascendance';
		if (isEeveeStarter && toID(this.set?.ability) === 'sinisterblaze') {
			// Ability-specific replacement: do not inherit Eevee-Starter's broad pool.
			moves = [...SINISTER_BLAZE_EEVEE_MOVES];
			sketchMoves = [];
		}
		if (isEeveeStarter && toID(this.set?.ability) === 'ascendance') {
			// Ability-specific replacement: Ascendance has only its declared pool.
			moves = [...ASCENDANCE_EEVEE_MOVES];
			sketchMoves = [];
		}
		if (species.id === 'sigilyphrejuv' ||
			(species.id === 'sigilyph' && toID(this.set?.ability) === 'aeviangrief')) {
			moves = [...AEVIAN_GRIEF_MOVE_IDS];
			sketchMoves = [];
		}
		if (species.id === 'alakazamrejuv' || (species.id === 'alakazam' && toID(this.set?.ability) === 'aeviandiscipline')) {
			moves = [...AEVIAN_DISCIPLINE_MOVES] as ID[];
			sketchMoves = [];
		}
		if (species.id === 'umbreon' && !isUmbreonAscendance) {
			moves = moves.filter(id => id !== 'radiantassault');
		}
		if (isEeveeStarter && !isHackmons && !['sinisterblaze', 'ascendance'].includes(toID(this.set?.ability))) {
			const removed = Dex.getCustomMoveRemovals(species.id);
			moves = moves.filter(id => !removed.includes(id));
		}
		if (isEeveeStarter) {
			const priority = new Map(eeveeStarterMoveOrder.map((id, index) => [id, index]));
			moves.sort((a, b) => {
				const aPriority = priority.get(a);
				const bPriority = priority.get(b);
				if (aPriority !== undefined || bPriority !== undefined) {
					if (aPriority === undefined) return 1;
					if (bPriority === undefined) return -1;
					if (aPriority !== bPriority) return aPriority - bPriority;
				}
				return a.localeCompare(b);
			});
		} else {
			moves.sort();
		}
		if (isUmbreonAscendance) {
			moves = ['radiantassault', ...moves.filter(id => id !== 'radiantassault')];
		}
		const pulseMoves = Dex.getPulseFixedMoves(species.id);
		if (pulseMoves) {
			moves = [...pulseMoves];
			sketchMoves = [];
		}
		sketchMoves.sort();

		const aevianKingMoves: SearchRow[] = [];
		if (['politoed','politoedrejuv'].includes(species.id) && toID(this.set?.ability) !== 'aevianking') moves = moves.filter(id => !AEVIAN_KING_MOVE_SOURCES[id] || AEVIAN_KING_ORDINARY_MOVES.includes(id));
		if (['politoed','politoedrejuv'].includes(species.id) && toID(this.set?.ability) === 'aevianking' && dex.gen >= 9) {
			const extras = Object.keys(AEVIAN_KING_MOVE_SOURCES).filter(id => !AEVIAN_KING_ORDINARY_MOVES.includes(id));
			moves = moves.filter(id => !extras.includes(id));
			aevianKingMoves.push(['header','Aevian King exclusive moves']);
			for (const id of extras) aevianKingMoves.push(['move', id as ID]);
		}
		const aevianAscendanceMoves: SearchRow[] = [];
		if (['poliwrath','poliwrathrejuv'].includes(species.id) && toID(this.set?.ability) !== 'aevianascendance') moves = moves.filter(id => !AEVIAN_ASCENDANCE_MOVE_SOURCES[id] || AEVIAN_ASCENDANCE_ORDINARY_MOVES.includes(id));
		if (['poliwrath','poliwrathrejuv'].includes(species.id) && toID(this.set?.ability) === 'aevianascendance' && dex.gen >= 9) {
			const extras = Object.keys(AEVIAN_ASCENDANCE_MOVE_SOURCES).filter(id => !AEVIAN_ASCENDANCE_ORDINARY_MOVES.includes(id));
			moves = moves.filter(id => !extras.includes(id));
			aevianAscendanceMoves.push(['header','Aevian Ascendance exclusive moves']);
			for (const id of extras) aevianAscendanceMoves.push(['move', id as ID]);
		}
		const aevianWebMoves: SearchRow[] = [];
		if (['galvantula','galvantularejuv'].includes(species.id) && toID(this.set?.ability) !== 'aevianweb') moves = moves.filter(id => !AEVIAN_WEB_MOVE_SOURCES[id] || AEVIAN_WEB_ORDINARY_MOVES.includes(id));
		if (['galvantula','galvantularejuv'].includes(species.id) && toID(this.set?.ability) === 'aevianweb' && dex.gen >= 9) {
			const extras = Object.keys(AEVIAN_WEB_MOVE_SOURCES).filter(id => !AEVIAN_WEB_ORDINARY_MOVES.includes(id));
			moves = moves.filter(id => !extras.includes(id));
			aevianWebMoves.push(['header','Aevian Web exclusive moves']);
			for (const id of extras) aevianWebMoves.push(['move', id as ID]);
		}
		const signatureMoves: SearchRow[] = [];
		// Promote only learned Yang/Rejuvenation moves, preserving fixed Pulse pools.
		if (!isHackmons && !pulseMoves) {
			moves = moves.filter(id => {
				if (!(window.BattleMovedex?.[id] as AnyObject)?.signatureCharacters?.length) return true;
				if (!signatureMoves.length) signatureMoves.push(['header', 'Signature moves']);
				signatureMoves.push(['move', id as ID]);
				return false;
			});
		}

		let usableMoves: SearchRow[] = [];
		let uselessMoves: SearchRow[] = [];
		for (const id of moves) {
			const isUsable = this.moveIsNotUseless(id as ID, species, moves, this.set);
			if (isUsable) {
				if (!usableMoves.length) usableMoves.push(['header', "Moves"]);
				usableMoves.push(['move', id as ID]);
			} else {
				if (!uselessMoves.length) uselessMoves.push(['header', "Usually useless moves"]);
				uselessMoves.push(['move', id as ID]);
			}
		}
		if (sketchMoves.length) {
			usableMoves.push(['header', "Sketched moves"]);
			uselessMoves.push(['header', "Useless sketched moves"]);
		}
		for (const id of sketchMoves) {
			const isUsable = this.moveIsNotUseless(id as ID, species, sketchMoves, this.set);
			if (isUsable) {
				usableMoves.push(['move', id as ID]);
			} else {
				uselessMoves.push(['move', id as ID]);
			}
		}
		return [...aevianKingMoves, ...aevianAscendanceMoves, ...aevianWebMoves, ...signatureMoves, ...usableMoves, ...uselessMoves];
	}
	filter(row: SearchRow, filters: string[][]) {
		if (!filters) return true;
		if (row[0] !== 'move') return true;
		const move = this.dex.moves.get(row[1]);
		for (const [filterType, value] of filters) {
			switch (filterType) {
			case 'type':
				if (move.type !== value) return false;
				break;
			case 'category':
				if (move.category !== value) return false;
				break;
			case 'pokemon':
				if (!this.canLearn(value as ID, move.id)) return false;
				break;
			}
		}
		return true;
	}
	sort(results: SearchRow[], sortCol: string, reverseSort?: boolean): SearchRow[] {
		const sortOrder = reverseSort ? -1 : 1;
		switch (sortCol) {
		case 'power':
			let powerTable: {[id: string]: number | undefined} = {
				return: 102, frustration: 102, spitup: 300, trumpcard: 200, naturalgift: 80, grassknot: 120,
				lowkick: 120, gyroball: 150, electroball: 150, flail: 200, reversal: 200, present: 120,
				wringout: 120, crushgrip: 120, heatcrash: 120, heavyslam: 120, fling: 130, magnitude: 150,
				beatup: 24, punishment: 1020, psywave: 1250, nightshade: 1200, seismictoss: 1200,
				dragonrage: 1140, sonicboom: 1120, superfang: 1350, endeavor: 1399, sheercold: 1501,
				fissure: 1500, horndrill: 1500, guillotine: 1500,
			};
			return results.sort(([rowType1, id1], [rowType2, id2]) => {
				let move1 = this.dex.moves.get(id1);
				let move2 = this.dex.moves.get(id2);
				let pow1 = move1.basePower || powerTable[id1] || (move1.category === 'Status' ? -1 : 1400);
				let pow2 = move2.basePower || powerTable[id2] || (move2.category === 'Status' ? -1 : 1400);
				return (pow2 - pow1) * sortOrder;
			});
		case 'accuracy':
			return results.sort(([rowType1, id1], [rowType2, id2]) => {
				let accuracy1 = this.dex.moves.get(id1).accuracy || 0;
				let accuracy2 = this.dex.moves.get(id2).accuracy || 0;
				if (accuracy1 === true) accuracy1 = 101;
				if (accuracy2 === true) accuracy2 = 101;
				return (accuracy2 - accuracy1) * sortOrder;
			});
		case 'pp':
			const maxPP = (id: string) => {
				const move = this.dex.moves.get(id);
				const pp = move.pp === 1 || move.noPPBoosts ? move.pp : move.pp * 8 / 5;
				return this.dex.gen < 3 ? Math.min(61, pp) : pp;
			};
			return results.sort(([rowType1, id1], [rowType2, id2]) => {
				let pp1 = maxPP(id1);
				let pp2 = maxPP(id2);
				return (pp2 - pp1) * sortOrder;
			});
		case 'name':
			return results.sort(([rowType1, id1], [rowType2, id2]) => {
				const name1 = id1;
				const name2 = id2;
				return (name1 < name2 ? -1 : name1 > name2 ? 1 : 0) * sortOrder;
			});
		}
		throw new Error("invalid sortcol");
	}
}

class BattleCategorySearch extends BattleTypedSearch<'category'> {
	getTable() {
		return {physical: 1, special: 1, status: 1};
	}
	getDefaultResults(): SearchRow[] {
		return [
			['category', 'physical' as ID],
			['category', 'special' as ID],
			['category', 'status' as ID],
		];
	}
	getBaseResults() {
		return this.getDefaultResults();
	}
	filter(row: SearchRow, filters: string[][]): boolean {
		throw new Error("invalid filter");
	}
	sort(results: SearchRow[], sortCol: string | null, reverseSort?: boolean): SearchRow[] {
		throw new Error("invalid sortcol");
	}
}

class BattleTypeSearch extends BattleTypedSearch<'type'> {
	getTable() {
		return window.BattleTypeChart;
	}
	getDefaultResults(): SearchRow[] {
		const results: SearchRow[] = [];
		for (let id in window.BattleTypeChart) {
			results.push(['type', id as ID]);
		}
		return results;
	}
	getBaseResults() {
		return this.getDefaultResults();
	}
	filter(row: SearchRow, filters: string[][]): boolean {
		throw new Error("invalid filter");
	}
	sort(results: SearchRow[], sortCol: string | null, reverseSort?: boolean): SearchRow[] {
		throw new Error("invalid sortcol");
	}
}
